// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23a0aec0%27%3e%3cpath d=%27M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

main {
  display: block;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

pre {
  font-family: monospace, monospace;
  font-size: 1em;
}

a {
  background-color: transparent;
}

b,
strong {
  font-weight: bolder;
}

code {
  font-family: monospace, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

img {
  border-style: none;
}

button,
input,
select {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none;
}

h1,
h2,
h3,
hr,
figure,
p,
pre {
  margin: 0;
}

button {
  background-color: transparent;
  background-image: none;
  padding: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

html {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 1.5;
}

*,
::before,
::after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e2e8f0;
}

hr {
  border-top-width: 1px;
}

img {
  border-style: solid;
}

input::placeholder {
  color: #a0aec0;
}

button,
[role="button"] {
  cursor: pointer;
}

h1,
h2,
h3 {
  font-size: inherit;
  font-weight: inherit;
}

a {
  color: inherit;
  text-decoration: inherit;
}

button,
input,
select {
  padding: 0;
  line-height: inherit;
  color: inherit;
}

pre,
code {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New",
    monospace;
}

img,
svg,
video,
canvas,
iframe,
embed {
  display: block;
  vertical-align: middle;
}

img,
video {
  max-width: 100%;
  height: auto;
}

.sp-form-input {
  appearance: none;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.25rem;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
}

.sp-form-input::placeholder {
  color: #a0aec0;
  opacity: 1;
}

.sp-form-input:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  border-color: #63b3ed;
}

.sp-form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background-repeat: no-repeat;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.25rem;
  padding-top: 0.5rem;
  padding-right: 2.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  background-position: right 0.5rem center;
  background-size: 1.5em 1.5em;
}

.sp-form-select::-ms-expand {
  color: #a0aec0;
  border: 0;
}

@media not print {
  .sp-form-select::-ms-expand {
    display: none;
  }
}

@media print and (-ms-high-contrast: active),
  print and (-ms-high-contrast: none) {
  .sp-form-select {
    padding-right: 0.75rem;
  }
}

.sp-form-select:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  border-color: #63b3ed;
}

.sp-form-checkbox {
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  user-select: none;
  flex-shrink: 0;
  height: 1em;
  width: 1em;
  color: #4299e1;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.25rem;
}

.sp-form-checkbox:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media not print {
  .sp-form-checkbox::-ms-check {
    border-width: 1px;
    color: transparent;
    background: inherit;
    border-color: inherit;
    border-radius: inherit;
  }
}

.sp-form-checkbox:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  border-color: #63b3ed;
}

.sp-bg-black {
  background-color: #000;
}

.sp-bg-white {
  background-color: #fff;
}

.sp-bg-blue-500 {
  background-color: #4299e1;
}

.hover\\:sp-bg-blue-700:hover {
  background-color: #2b6cb0;
}

.sp-rounded {
  border-radius: 0.25rem;
}

.sp-rounded-md {
  border-radius: 0.375rem;
}

.sp-rounded-full {
  border-radius: 9999px;
}

.sp-rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.sp-rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.sp-rounded-bl {
  border-bottom-left-radius: 0.25rem;
}

.sp-border-dotted {
  border-style: dotted;
}

.sp-border-none {
  border-style: none;
}

.sp-border-2 {
  border-width: 2px;
}

.sp-border {
  border-width: 1px;
}

.sp-cursor-pointer {
  cursor: pointer;
}

.sp-cursor-move {
  cursor: move;
}

.sp-block {
  display: block;
}

.sp-inline-block {
  display: inline-block;
}

.sp-inline {
  display: inline;
}

.sp-flex {
  display: flex;
}

.sp-inline-flex {
  display: inline-flex;
}

.sp-hidden {
  display: none;
}

.sp-flex-row {
  flex-direction: row;
}

.sp-flex-row-reverse {
  flex-direction: row-reverse;
}

.sp-flex-col {
  flex-direction: column;
}

.sp-flex-wrap {
  flex-wrap: wrap;
}

.sp-items-start {
  align-items: flex-start;
}

.sp-items-end {
  align-items: flex-end;
}

.sp-items-center {
  align-items: center;
}

.sp-items-baseline {
  align-items: baseline;
}

.sp-items-stretch {
  align-items: stretch;
}

.sp-self-start {
  align-self: flex-start;
}

.sp-self-center {
  align-self: center;
}

.sp-justify-start {
  justify-content: flex-start;
}

.sp-justify-end {
  justify-content: flex-end;
}

.sp-justify-center {
  justify-content: center;
}

.sp-justify-between {
  justify-content: space-between;
}

.sp-justify-around {
  justify-content: space-around;
}

.sp-justify-evenly {
  justify-content: space-evenly;
}

.sp-font-sans {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.sp-font-semibold {
  font-weight: 600;
}

.sp-font-bold {
  font-weight: 700;
}

.sp-h-3 {
  height: 0.75rem;
}

.sp-h-4 {
  height: 1rem;
}

.sp-h-6 {
  height: 1.5rem;
}

.sp-h-8 {
  height: 2rem;
}

.sp-h-full {
  height: 100%;
}

.sp-leading-none {
  line-height: 1;
}

.sp-m-2 {
  margin: 0.5rem;
}

.sp-m-auto {
  margin: auto;
}

.sp-mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.sp-mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.sp-my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.sp-mt-1 {
  margin-top: 0.25rem;
}

.sp-mr-1 {
  margin-right: 0.25rem;
}

.sp-mb-1 {
  margin-bottom: 0.25rem;
}

.sp-mt-2 {
  margin-top: 0.5rem;
}

.sp-mr-2 {
  margin-right: 0.5rem;
}

.sp-mb-2 {
  margin-bottom: 0.5rem;
}

.sp-ml-2 {
  margin-left: 0.5rem;
}

.sp-mt-3 {
  margin-top: 0.75rem;
}

.sp-mb-3 {
  margin-bottom: 0.75rem;
}

.sp-ml-3 {
  margin-left: 0.75rem;
}

.sp-mt-4 {
  margin-top: 1rem;
}

.sp-mr-4 {
  margin-right: 1rem;
}

.sp-mb-4 {
  margin-bottom: 1rem;
}

.sp-ml-4 {
  margin-left: 1rem;
}

.sp-mr-6 {
  margin-right: 1.5rem;
}

.sp-mb-6 {
  margin-bottom: 1.5rem;
}

.sp-ml-6 {
  margin-left: 1.5rem;
}

.sp-mt-8 {
  margin-top: 2rem;
}

.sp-object-cover {
  object-fit: cover;
}

.sp-opacity-25 {
  opacity: 0.25;
}

.sp-opacity-50 {
  opacity: 0.5;
}

.sp-opacity-75 {
  opacity: 0.75;
}

.sp-outline-none {
  outline: 0;
}

.focus\\:sp-outline-none:focus {
  outline: 0;
}

.sp-p-1 {
  padding: 0.25rem;
}

.sp-p-3 {
  padding: 0.75rem;
}

.sp-p-4 {
  padding: 1rem;
}

.sp-p-10 {
  padding: 2.5rem;
}

.sp-py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.sp-px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.sp-py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.sp-px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.sp-py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.sp-px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.sp-px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.sp-px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.sp-px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.sp-py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.sp-pt-1 {
  padding-top: 0.25rem;
}

.sp-pb-1 {
  padding-bottom: 0.25rem;
}

.sp-pt-2 {
  padding-top: 0.5rem;
}

.sp-pr-2 {
  padding-right: 0.5rem;
}

.sp-pb-2 {
  padding-bottom: 0.5rem;
}

.sp-pb-4 {
  padding-bottom: 1rem;
}

.sp-pl-4 {
  padding-left: 1rem;
}

.sp-pb-5 {
  padding-bottom: 1.25rem;
}

.sp-pb-6 {
  padding-bottom: 1.5rem;
}

.sp-absolute {
  position: absolute;
}

.sp-relative {
  position: relative;
}

.sp-top-0 {
  top: 0;
}

.sp-right-0 {
  right: 0;
}

.sp-bottom-0 {
  bottom: 0;
}

.sp-left-0 {
  left: 0;
}

.sp-shadow-inner {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.sp-fill-current {
  fill: currentColor;
}

.sp-text-left {
  text-align: left;
}

.sp-text-center {
  text-align: center;
}

.sp-text-right {
  text-align: right;
}

.sp-text-black {
  color: #000;
}

.sp-text-white {
  color: #fff;
}

.sp-text-xs {
  font-size: 0.8125rem;
}

.sp-text-sm {
  font-size: 0.875rem;
}

.sp-text-base {
  font-size: 1rem;
}

.sp-text-lg {
  font-size: 1.125rem;
}

.sp-italic {
  font-style: italic;
}

.sp-no-underline {
  text-decoration: none;
}

.sp-antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sp-whitespace-no-wrap {
  white-space: nowrap;
}

.sp-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sp-w-3 {
  width: 0.75rem;
}

.sp-w-4 {
  width: 1rem;
}

.sp-w-5 {
  width: 1.25rem;
}

.sp-w-6 {
  width: 1.5rem;
}

.sp-w-8 {
  width: 2rem;
}

.sp-w-24 {
  width: 6rem;
}

.sp-w-1\\/3 {
  width: 33.333333%;
}

.sp-w-1\\/4 {
  width: 25%;
}

.sp-w-2\\/4 {
  width: 50%;
}

.sp-w-1\\/5 {
  width: 20%;
}

.sp-w-1\\/6 {
  width: 16.666667%;
}

.sp-w-full {
  width: 100%;
}

.sp-z-0 {
  z-index: 0;
}

.sp-z-40 {
  z-index: 40;
}

.sp-z-50 {
  z-index: 50;
}

.sp-gap-2 {
  grid-gap: 0.5rem;
  gap: 0.5rem;
}

html {
  scroll-behavior: smooth;
}

body {
  background-color: #fff;
}

#sp-theme-template {
  display: flex;
  flex-direction: column;
  position: relative;
}

#sp-page {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 10;
  background-color: transparent !important;
  background-image: none !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

hr {
  margin: 20px 0;
  opacity: 0.5;
  border-color: currentColor;
}

ol {
  list-style: number;
  list-style-position: inside;
}

ul {
  list-style: disc;
  list-style-position: inside;
}

fieldset {
  padding: 0;
  margin: 0;
}

legend {
  font-weight: bold;
}

blockquote {
  background: #f9f9f9;
  border-left: 10px solid #ccc;
  margin: 1.5em 10px;
  padding: 0.5em 10px;
  quotes: "\\201C""\\201D""\\2018""\\2019";
}

blockquote:before {
  color: #ccc;
  content: open-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
}

blockquote p {
  display: inline;
}

.sp-el-section {
  padding: 10px;
}

.sp-el-row {
  max-width: 1000px;
  padding: 0;
}

.sp-el-col {
  padding: 10px;
}

.sp-el-block {
  padding: 10px;
}

#sp-page h1,
#sp-page h2,
#sp-page h3,
#sp-page h4,
#sp-page h5,
#sp-page h6 {
  margin: 0;
}

.sp-form-input:focus {
  box-shadow: none;
}

.sp-login-wrapper input[type="password"] {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.sp-optin-submit:active {
  outline: 0;
}

.sp-content-1 {
  align-items: center;
  justify-content: flex-start;
}

.sp-content-2 {
  align-items: flex-start;
  justify-content: flex-start;
}

.sp-content-3 {
  align-items: flex-end;
  justify-content: flex-start;
}

.sp-content-4 {
  align-items: center;
  justify-content: center;
}

.sp-content-5 {
  align-items: flex-start;
  justify-content: center;
}

.sp-content-6 {
  align-items: flex-end;
  justify-content: center;
}

.sp-content-7 {
  align-items: flex-start;
  justify-content: flex-end;
}

.sp-content-8 {
  align-items: center;
  justify-content: flex-end;
}

.sp-content-9 {
  align-items: flex-end;
  justify-content: flex-end;
}

.sp-header-tag-h1,
h1 {
  font-size: 36px;
}

.sp-header-tag-h2,
h2 {
  font-size: 30px;
}

.sp-header-tag-h3,
h3 {
  font-size: 24px;
}

.sp-header-tag-h4,
h4 {
  font-size: 18px;
}

.sp-header-tag-h5,
h5 {
  font-size: 14px;
}

.sp-header-tag-h6,
h6 {
  font-size: 12px;
}

.sp-header-tag-h1,
h1,
.sp-header-tag-h2,
h2,
.sp-header-tag-h3,
h3,
.sp-header-tag-h4,
h4,
.sp-header-tag-h5,
h5,
.sp-header-tag-h6,
h6 {
  line-height: 1.2;
}

img {
  display: inline-block;
}

.fab {
  font-weight: normal;
}

.spBgcover {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: fixed;
  min-height: 100%;
}

.spBgcoverscroll {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: scroll;
  min-height: 100%;
}

.spBgcontain {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: fixed;
  min-height: 100%;
}

.spBgcontainscroll {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: scroll;
  min-height: 100%;
}

@supports (-webkit-touch-callout: none) {
  .spBgcover,
  .spBgcontain {
    background-attachment: scroll;
  }
}

.spBgfull {
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: scroll;
  min-height: 100%;
}

.spBgfullbottom {
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-attachment: scroll;
  min-height: 100%;
}

.spBgrepeat {
  background-repeat: repeat;
  background-position: center top;
  background-attachment: scroll;
  min-height: 100%;
}

.spBgrepeattop {
  background-repeat: repeat-x;
  background-position: center top;
  background-attachment: scroll;
}

.spBgrepeatbottom {
  background-repeat: repeat-x;
  background-position: center bottom;
  background-attachment: scroll;
  min-height: 100%;
}

.spBgrepeatvc {
  background-repeat: repeat-y;
  background-position: center top;
  background-attachment: scroll;
  min-height: 100%;
}

#sp-page .sp-form-input {
  border-width: 0;
}

#sp-page input[type="text"],
#sp-page input[type="password"],
#sp-page input[type="email"],
#sp-page input[type="url"],
#sp-page input[type="date"],
#sp-page input[type="month"],
#sp-page input[type="time"],
#sp-page input[type="datetime"],
#sp-page input[type="datetime-local"],
#sp-page input[type="week"],
#sp-page input[type="number"],
#sp-page input[type="search"],
#sp-page input[type="tel"],
#sp-page input[type="color"],
#sp-page select,
#sp-page textarea {
  border: 1px #ccc solid;
  background: #fff;
}

.sp-video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}

.sp-video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

.embed-responsive {
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  overflow: hidden;
  margin-bottom: 20px;
}

.embed-responsive .embed-responsive-item,
.embed-responsive iframe {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-16by9 {
  padding-bottom: 56.25%;
}

.wp-embed-responsive .wp-embed-aspect-4-3 .wp-block-embed__wrapper:before,
.wp-embed-responsive .wp-has-aspect-ratio .wp-block-embed__wrapper:before {
  padding-top: 0 !important;
}

.sp-map-responsive {
  position: relative;
  height: 0;
}

.sp-map-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

.sp-button {
  border-radius: 4px;
}

a.sp-button:hover {
  text-decoration: none !important;
  transition: 0.3s;
}

.sp-ss:hover,
.sp-sp:hover {
  filter: brightness(90%);
  transition: 0.3s;
  text-decoration: none;
}

.sp-ss-twitter {
  background: #000;
  color: #fff !important;
  text-decoration: none;
}

.sp-ss-facebook {
  background: #1877f2;
  color: #fff !important;
  text-decoration: none;
}

.sp-ss-linkedin {
  background: #0073b1;
  color: #fff !important;
  text-decoration: none;
}

.sp-ss-pinterest {
  background: #e60023;
  color: #fff !important;
  text-decoration: none;
}

.sp-ss {
  border-radius: 3px;
  font-family: sans-serif;
}

.sp-ss-sm {
  padding: 2px 5px;
  font-size: 13px;
}

.sp-ss-md {
  padding: 4px 10px;
  font-size: 16px;
}

.sp-ss-lg {
  padding: 8px 14px;
  font-size: 20px;
}

.sp-starrating i:last-of-type {
  padding-right: 0 !important;
}

summary::-webkit-details-marker {
  display: none;
}

details > summary:first-of-type {
  list-style-type: none;
}

details {
  display: block;
  width: 100%;
}

details .sp-acc-open {
  display: none;
}

details[open] .sp-acc-closed {
  display: none;
}

details[open] .sp-acc-open {
  display: block;
}

summary {
  outline: 0;
  cursor: pointer;
}

.sp-accordion-wrapper hr {
  margin: 0;
}

.woocommerce input,
.woocommerce select,
.woocommerce textarea {
  border-color: #ddd;
  border-style: solid;
  border-width: 1px;
  background-color: #fff;
  padding: 8px;
  border-radius: 3px;
}

.select2-container--default .select2-selection--single {
  border-color: #ddd !important;
  padding-top: 2px;
  height: 36px !important;
}

.select2-selection__rendered {
  border-color: transparent !important;
}

.woocommerce #place_order {
  width: 100%;
  margin-top: 10px;
}

.woocommerce-additional-fields h3 {
  margin-top: 10px;
}

.wc-proceed-to-checkout .checkout-button {
  width: 100%;
  text-align: center;
}

.woocommerce .onsale {
  min-width: 50px !important;
  min-height: 50px !important;
  font-size: 13px;
}

#cspio-bypass {
  border: 1px solid #ccc !important;
}

#cspio-bypass-btn {
  color: #fff;
}

.sp-testimonials-wrapper {
  position: relative;
}

.sp-dynamic-text {
  visibility: hidden;
}

.sp-imagecarousels-wrapper {
  position: relative;
}

.sp-progressbar-block-template-2 > div {
  border-bottom: 3px solid rgba(0, 0, 0, 0.25);
}

.sp-progressbar-block-template-3 > div {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 16px 16px;
}

.sp-progressbar-block-template-4 > div {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 16px 16px;
  animation: progress-bar-stripes 1s linear infinite;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 0 16px;
  }

  to {
    background-position: 0 0;
  }
}

.sp-testimonial-img {
  width: 60px;
  height: 60px;
}

.sp-testimonial-nav button:first-child,
.sp-testimonial-nav button:last-child {
  background: transparent;
}

.sp-socialprofiles-style-1 .sp-sp-twitter {
  color: #000 !important;
}

.sp-socialprofiles-style-1 .sp-sp-facebook,
.sp-socialprofiles-style-1 .sp-sp-facebook-messenger {
  color: #1877f2 !important;
}

.sp-socialprofiles-style-1 .sp-sp-slack {
  color: #4a154b !important;
}

.sp-socialprofiles-style-1 .sp-sp-vimeo {
  color: #2fb1e3 !important;
}

.sp-socialprofiles-style-1 .sp-sp-weibo {
  color: #ce282b !important;
}

.sp-socialprofiles-style-1 .sp-sp-whatsapp {
  color: #38af48 !important;
}

.sp-socialprofiles-style-1 .sp-sp-tiktok {
  color: #fe2c55 !important;
}

.sp-socialprofiles-style-1 .sp-sp-x-twitter {
  color: #fe2c55 !important;
}

.sp-socialprofiles-style-1 .sp-sp-imdb {
  color: #f5c517 !important;
}

.sp-socialprofiles-style-1 .sp-sp-linkedin {
  color: #0073b1 !important;
}

.sp-socialprofiles-style-1 .sp-sp-pinterest {
  color: #e60023 !important;
}

.sp-socialprofiles-style-1 .sp-sp-youtube {
  color: #f00 !important;
}

.sp-socialprofiles-style-1 .sp-sp-instagram {
  color: #f77737 !important;
}

.sp-socialprofiles-style-1 .sp-sp-snapchat {
  color: #fffc00 !important;
}

.sp-socialprofiles-style-1 .sp-sp-wordpress {
  color: #0073aa !important;
}

.sp-socialprofiles-style-1 .sp-sp-github {
  color: #000 !important;
}

.sp-socialprofiles-style-1 .sp-sp-soundcloud {
  color: #fe5000 !important;
}

.sp-socialprofiles-style-1 .sp-sp-rss {
  color: #ee802f !important;
}

.sp-socialprofiles-style-1 .sp-sp-envelope {
  color: #db4437 !important;
}

.sp-socialprofiles-style-1 .sp-sp-phone {
  color: #2c9ada !important;
}

.sp-socialprofiles-style-1 .sp-sp-medium-m {
  color: #21de68 !important;
}

.sp-socialprofiles-style-1 .sp-sp-discord {
  color: #5567e3 !important;
}

.sp-socialprofiles-style-1 .sp-sp-telegram-plane {
  color: #299ccd !important;
}

.sp-sp {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sp-sp-twitter {
  background: #000;
  text-decoration: none;
}

.sp-sp-facebook,
.sp-sp-facebook-messenger {
  background: #1877f2;
  text-decoration: none;
}

.sp-sp-slack {
  background: #4a154b;
  text-decoration: none;
}

.sp-sp-vimeo {
  background: #2fb1e3;
  text-decoration: none;
}

.sp-sp-weibo {
  background: #ce282b;
  text-decoration: none;
}

.sp-sp-whatsapp {
  background: #38af48;
  text-decoration: none;
}

.sp-sp-tiktok {
  background: #fe2c55;
  text-decoration: none;
}

.sp-sp-linkedin {
  background: #0073b1;
  text-decoration: none;
}

.sp-sp-pinterest {
  background: #e60023;
  text-decoration: none;
}

.sp-sp-youtube {
  background: red;
  text-decoration: none;
}

.sp-sp-instagram {
  background: #f77737;
  text-decoration: none;
}

.sp-sp-snapchat {
  background: #fffc00;
  text-decoration: none;
}

.sp-sp-wordpress {
  background: #0073aa;
  text-decoration: none;
}

.sp-sp-github {
  background: #000;
  text-decoration: none;
}

.sp-sp-soundcloud {
  background: #fe5000;
  text-decoration: none;
}

.sp-sp-rss {
  background: #ee802f;
  text-decoration: none;
}

.sp-sp-envelope {
  background: #db4437;
  text-decoration: none;
}

.sp-sp-phone {
  background: #2c9ada;
  text-decoration: none;
}

.sp-sp-medium-m {
  background: #21de68;
  text-decoration: none;
}

.sp-sp-discord {
  background: #5567e3;
  text-decoration: none;
}

.sp-sp-telegram-plane {
  background: #299ccd;
  text-decoration: none;
}

.sp-countdown-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sp-cd-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sp-cd-amount {
  padding: 20px;
  line-height: 1;
}

.sp-countdown-sm .sp-cd-amount {
  font-size: 20px;
  padding: 10px;
}

.sp-countdown-md .sp-cd-amount {
  font-size: 30px;
  padding: 15px;
}

.sp-countdown-lg .sp-cd-amount {
  font-size: 40px;
  padding: 20px;
}

.sp-bulletlist-block-template-0 .sp-icon-wrapper i {
  width: auto !important;
  line-height: 1 !important;
}

.sp-bulletlist-block-template-1 .sp-icon-wrapper i {
  text-align: center;
  background: #fff;
  border-radius: 999px;
}

.sp-bulletlist-block-template-2 .sp-icon-wrapper i {
  text-align: center;
  background: #fff;
  border-radius: 6px;
}

.sp-bulletlist-block-template-3 .sp-icon-wrapper i {
  text-align: center;
  background: #fff;
  border-radius: 0;
}

.sp-bulletlist-block-template-4 .sp-icon-wrapper i {
  text-align: center;
  background: #444;
  border-radius: 999px;
}

.sp-bulletlist-block-template-5 .sp-icon-wrapper i {
  text-align: center;
  background: #444;
  border-radius: 6px;
}

.sp-bulletlist-block-template-6 .sp-icon-wrapper i {
  text-align: center;
  background: #444;
  border-radius: 0;
}

.sp-input-size-2 {
  height: 33px;
}

.sp-input-size-3 {
  height: 42px;
}

.sp-input-size-4 {
  height: 56px;
}

@keyframes sp-ajax-stripes {
  from {
    background-position: 48px 0;
  }

  to {
    background-position: 0 0;
  }
}

.sp-ajax-animated {
  animation: sp-ajax-stripes 1s linear infinite;
}

.sp-ajax-striped {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  ) !important;
  background-size: 1rem 1rem !important;
}

#tubular-container iframe {
  opacity: 0;
  transition: opacity 0.5s;
}

#tubular-container .active {
  opacity: 1;
}

.sp-spacer {
    height: 37px;
  }

@media (max-width: 640px) {
  .sp-spacer {
    height: 1vh !important;
  }

  .sp-countdown-group {
    flex-wrap: wrap;
  }

  .sp-cd-group {
    margin-bottom: 1vh !important;
  }

  .sp-socialsharing-wrapper,
  .sp-nav,
  .sp-button-wrapper,
  .sp-image-wrapper {
    text-align: center !important;
    justify-content: center !important;
  }

  .sp-pricing-table-wrapper {
    border: 1px #ffffff1f solid;
    text-align: center !important;
    justify-content: center !important;
  }

  @media (max-width: 768px) {
    .sp-el-section,
    .sp-el-row,
    .sp-el-col,
    .sp-el-block,
    .sp-optin-wrapper,
    .sp-testimonials-wrapper,
    .sp-testimonial-wrapper {
      padding-top: 4px !important;
    }
  }

  .sp-el-block {
    padding: 0px;
    padding-bottom: 20px;
  }

  .sp-w-full {
    width: 100% !important;
  }

  .sp-optinform-field,
  .sp-optinform-btn {
    display: block !important;
    width: 100% !important;
  }

  /*img:not(".sp-testimonial-img") {*/
  /*  height: auto !important*/
  /*}*/

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-align: center !important;
  }

  .sp-socialprofiles-wrapper {
    text-align: center !important;
    justify-content: center !important;
  }

  .sp-feature-wrapper {
    text-align: center !important;
  }

  .sp-feature-wrapper img,
  .sp-feature-wrapper i {
    margin: 0 !important;
    margin-bottom: 16px !important;
  }

  .sp-wccustomproductsgrid-wrapper li.product {
    float: none !important;
    width: 100% !important;
  }
}

#cspio-bypass-btn {
  font-size: 15px;
  height: 27px;
  padding: 0 14px;
  border-radius: 4px;
}

input[type="password"] {
  appearance: none;
  background-color: #fff;
  border-width: 1px;
  border-radius: 0.25rem;
  padding-top: 0.25rem;
  padding-right: 0.5rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  line-height: 1.5;
}

.sp-credit {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  bottom: 0;
  right: 20px;
  font-size: 10px;
  padding: 7px;
  border-radius: 2px;
  line-height: 1;
  color: #fff;
  z-index: 10;
  font-family: sans-serif;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.sp-credit img {
  width: 64px;
}

.sp-credit span {
  padding-top: 3px;
  padding-right: 2px;
  color: #fff;
}

.sp-credit a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sp-plan-price {
  text-align: center;
}

.sp-plan-price-sup {
  top: -2.5em;
}

.sp-plan-price-sub {
  left: -7%;
  bottom: 0;
}

.sp-notifications-custom {
  background: #fdf6f4;
  border: 1px solid #f6d2c7;
}

.sp-notification-button {
  background: #0f8a5e !important;
  border: #0f8a5e !important;
  color: #fff !important;
  text-decoration: none !important;
  text-shadow: none !important;
}

.pabloo-menu {
  box-sizing: border-box;
}

.pabloo-menu-fixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3;
}

.pabloo-menu-list,
.menu-item {
  position: relative;
}

.pabloo-menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-item {
  padding: 0;
  margin: 0;
  height: 100%;
}

.pabloo-menu-link,
.pabloo-menu-heading {
  display: block;
  text-decoration: none;
  white-space: nowrap;
}

.pabloo-menu-horizontal .nav-menu {
  width: 100%;
  white-space: nowrap;
}

.pabloo-menu-horizontal .nav-menu .pabloo-menu-list {
  display: inline-block;
}

.pabloo-menu-horizontal .nav-menu .menu-item,
.pabloo-menu-horizontal .nav-menu .pabloo-menu-heading,
.pabloo-menu-horizontal .nav-menu .pabloo-menu-separator {
  display: inline-block;
  vertical-align: middle;
}

.menu-item .menu-item {
  display: block;
  white-space: nowrap;
}

.pabloo-menu-horizontal .menu-item .menu-item {
  display: block;
}

.sub-menu {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  margin: 0;
  padding: 0;
  z-index: 3;
}

.pabloo-menu-horizontal .nav-menu .sub-menu {
  left: 0;
  top: auto;
  width: inherit;
}

.pabloo-menu-horizontal .nav-menu .sub-menu .sub-menu {
  left: 100%;
  top: 0;
  width: inherit;
}

.menu-item-has-children:hover > .sub-menu,
.pabloo-menu-active > .sub-menu {
  display: block;
  position: absolute;
}

.menu-item-has-children > a:after {
  padding-left: 0.5em;
  content: "\\25B8";
  font-size: inherit;
}

.menu-item-has-children .sub-menu-toggle {
  display: none;
}

.pabloo-menu-horizontal .nav-menu .menu-item-has-children > a:after {
  content: "\\25BE";
}

.pabloo-menu-scrollable {
  overflow-y: scroll;
  overflow-x: hidden;
}

.pabloo-menu-scrollable .pabloo-menu-list {
  display: block;
}

.h .pabloo-menu-horizontal.pabloo-menu-scrollable .pabloo-menu-list {
  display: inline-block;
}

.h .pabloo-menu-horizontal.pabloo-menu-scrollable {
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: hidden;
  padding: 0.5em 0;
}

.pabloo-menu-separator,
.h .pabloo-menu-horizontal .sub-menu .pabloo-menu-separator {
  background-color: #ccc;
  height: 1px;
  margin: 0.3em 0;
}

.h .pabloo-menu-horizontal .pabloo-menu-separator {
  width: 1px;
  height: 1.3em;
  margin: 0 0.3em;
}

.h .pabloo-menu-horizontal .sub-menu .pure-menu-separator {
  display: block;
  width: auto;
}

.pabloo-menu-heading {
  text-transform: uppercase;
  color: #565d64;
}

.pabloo-menu-link {
  color: #777;
}

.sub-menu {
  background-color: #fff;
}

.pabloo-menu-link,
.pabloo-menu-heading {
  padding: 0.5em 1em;
}

.pabloo-menu-disabled {
  opacity: 0.5;
}

.pabloo-menu-disabled .pabloo-menu-link:hover {
  background-color: transparent;
  cursor: default;
}

.pabloo-menu-active > .pabloo-menu-link,
.pabloo-menu-link:hover,
.pabloo-menu-link:focus {
  background-color: #eee;
}

.pabloo-menu-selected > .pabloo-menu-link,
.pabloo-menu-selected > .pabloo-menu-link:visited {
  color: #000;
}

.nav-bar {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  padding: 1rem 1.5rem;
}

.hamburger {
  display: none;
}

.bar {
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px auto;
  transition: all 0.3s ease-in-out;
  background-color: #101010;
}

.sp-nested-nav-wrapper .nav-bar {
  padding: 0;
}

@media only screen and (max-width: 786px) {
  .custom-restricted-width {
    width: 99%;
    display: block;
  }

  .sp-nested-nav-wrapper {
    width: 100%;
  }

  .sp-mobile-menu-true ul.pabloo-menu-list {
    display: inline-block;
    width: 100%;
    text-align: left;
  }

  .sp-mobile-menu-true .nav-bar {
    padding: 0;
  }

  .sp-mobile-menu-true .menu-item-has-children:hover > .sub-menu {
    width: 100%;
    display: none;
  }

  .sp-mobile-menu-true
    .menu-item-has-children.pabloo-menu-active
    > .sub-menu {
    width: 100%;
    display: block !important;
    left: 0;
    position: relative;
  }

  .pabloo-menu-horizontal.sp-mobile-menu-true .nav-menu .sub-menu .sub-menu {
    left: 0;
    top: auto;
    width: inherit;
  }

  .pabloo-menu-horizontal.sp-mobile-menu-true .menu-item,
  .pabloo-menu-horizontal.sp-mobile-menu-true .pure-menu-heading,
  .pabloo-menu-horizontal.sp-mobile-menu-true .pure-menu-separator {
    display: block !important;
    padding: 0 !important;
  }

  .custom-restricted-width.sp-mobile-menu-true .menu-item,
  .custom-restricted-width.sp-mobile-menu-true .pure-menu-heading,
  .custom-restricted-width.sp-mobile-menu-true .pure-menu-separator {
    display: block !important;
    padding: 0 !important;
  }

  .sp-mobile-menu-true .menu-item a {
    display: block;
    width: 100%;
  }

  .sp-mobile-menu-true .nav-menu .menu-item {
    display: block !important;
    font-size: 22px;
    line-height: 26px;
  }

  .sp-mobile-menu-true .nav-menu {
    display: none;
  }

  .sp-mobile-menu-true .nav-menu.active {
    display: block;
    background-color: transparent;
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  .sp-mobile-menu-true .nav-menu.active {
    left: 0;
  }

  .sp-mobile-menu-true .hamburger {
    display: block;
    cursor: pointer;
  }

  .sp-mobile-menu-true .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }

  .sp-mobile-menu-true .hamburger.active .bar:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }

  .sp-mobile-menu-true .hamburger.active .bar:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }

  .sp-mobile-menu-false .nav-menu .pabloo-menu-list {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .sp-nav-wrapper,
  .sp-nav-wrapper li {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 !important;
    padding: 5px 0 !important;
  }
}

.sub-menu .menu-item {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

@media (max-width: 786px) {
  .menu-item {
    margin-top: 2px !important;
    margin-bottom: 2px !important;
  }

  .menu-item a {
    text-align: left !important;
  }
}

.sp-mobile-menu-true ul.sub-menu {
  padding-left: 10px;
}

.custom-restricted-width .menu-item:first-child {
  padding-top: 0 !important;
}

.custom-restricted-width .menu-item:last-child {
  padding-bottom: 0 !important;
}

.sub-menu li {
  text-align: left !important;
}

.custom-restricted-width .sub-menu .menu-item {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.pabloo-menu-list > ul {
  display: flex;
  list-style: none;
}

.pabloo-menu-list > ul li {
  padding: 0 20px;
}

.pabloo-menu-list > ul li:nth-of-type(1n + 4) {
  display: none;
}

.woocommerce .products ul,
.woocommerce ul.products {
  margin-bottom: 0 !important;
}

.sp-custom-grid {
  display: grid;
}

.sp-custom-gap-4 {
  grid-gap: 1rem;
  gap: 1rem;
}

.sp-custom-grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.sp-custom-grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.sp-custom-grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.sp-custom-grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.sp-custom-grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.sp-custom-grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.sp-custom-grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.sp-custom-grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.sp-custom-grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

.sp-custom-grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

.sp-custom-grid-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}

.sp-custom-grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.sp-custom-col-span-1 {
  grid-column: span 1 / span 1;
}

.sp-custom-col-span-2 {
  grid-column: span 2 / span 2;
}

.sp-custom-col-span-3 {
  grid-column: span 3 / span 3;
}

.sp-custom-col-span-4 {
  grid-column: span 4 / span 4;
}

.sp-custom-col-span-5 {
  grid-column: span 5 / span 5;
}

.sp-custom-col-span-6 {
  grid-column: span 6 / span 6;
}

.sp-custom-col-span-7 {
  grid-column: span 7 / span 7;
}

.sp-custom-col-span-8 {
  grid-column: span 8 / span 8;
}

.sp-custom-col-span-9 {
  grid-column: span 9 / span 9;
}

.sp-custom-col-span-10 {
  grid-column: span 10 / span 10;
}

.sp-custom-col-span-11 {
  grid-column: span 11 / span 11;
}

.sp-custom-col-span-12 {
  grid-column: span 12 / span 12;
}

.sp-custom-col-span-full {
  grid-column: 1 / -1;
}

.woocommerce .products ul,
.woocommerce ul.products {
  margin-bottom: 0 !important;
}

.woocommerce .button.wp-element-button {
  padding: 10px;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
}

.gallery-item {
  margin-right: 10px;
  margin-bottom: 10px;
}

.sp-searchform button {
  background: #ccc;
}

.sp-searchform input {
  color: #444;
}

@media only screen and (max-width: 480px) {
  .sp-custom-grid-cols-2 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-3 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-4 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-5 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-6 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-7 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-8 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-9 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-10 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-11 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sp-custom-grid-cols-12 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
}

.sp-postauthorbox-avatar img {
  border-radius: 9999px;
}

.sp-flex-none.sp-postauthorbox-avatar {
  flex: none;
}

.sp-p-2.sp-postauthorbox-avatar {
  padding: 0.5rem;
}

.sp-postcomments-wrapper .comments-area .comments-title,
#reply-title {
  font-size: 24px;
}

.sp-postcomments-wrapper .comments-area .avatar {
  border-radius: 9999px;
  float: left;
  margin: 0 10px 0 0;
  width: 48px;
  height: 48px;
  margin-left: -27px;
}

.sp-postcomments-wrapper .comments-area .says {
  display: none;
}

.sp-postcomments-wrapper .comments-area .comment-author {
  margin-top: -90px;
}

.sp-postcomments-wrapper .comments-area .fn {
  font-style: normal;
  margin: 5px 0 0 0;
  font-size: 18px;
}

.sp-postcomments-wrapper .comments-area .comment-metadata {
  font-size: 12px;
  margin-bottom: 45px;
}

.sp-postcomments-wrapper .comments-area .comment-body {
  border: 1px solid #ebebeb;
  padding: 30px 30px 10px 30px;
  margin-top: 75px;
  margin-bottom: 20px;
  position: relative;
}

.pingback .comment-body,
.pingback .comment-author {
  margin-top: 0 !important;
}

.sp-postcomments-wrapper .comments-area .comment-body p {
  line-height: 1.625;
  margin-bottom: 25px;
}

.sp-postcomments-wrapper .comments-area .reply a {
  padding: 5px 10px;
  color: #444;
  text-decoration: none;
  background: #e9eaeb;
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 12px;
}

.sp-postcomments-wrapper .comments-area .comment-form .logged-in-as {
  font-size: 12px;
}

.sp-postcomments-wrapper #comments ol {
  list-style: none;
}

.sp-postcomments-wrapper .comment-list {
  padding-left: 0;
}

.sp-postcomments-wrapper #comments .edit-link {
  text-decoration: none;
}

.sp-postcomments-wrapper .sp-postcomments-no-display {
  display: none;
}

.comment-form-cookies-consent {
  display: flex;
  align-items: center;
}

#wp-comment-cookies-consent {
  margin-right: 8px;
}

.comment-form-author,
.comment-form-email,
.comment-form-cookies-consent {
  margin-bottom: 10px;
}

.sp-postcomments-wrapper .comments-area .comment-form label {
  display: block;
  font-size: 13px;
}

.sp-postcomments-wrapper .comments-area .comment-form textarea {
  height: 130px;
  max-width: 100%;
}

/*.sp-postcomments-wrapper .comments-area .comment-form input:not:[type="submit"],*/
.sp-postcomments-wrapper .comments-area .comment-form textarea {
  font-size: 16px;
  padding: 12px 15px;
  width: 100%;
  border-radius: 3px;
  margin-bottom: 16px;
}

.sp-postcomments-wrapper .comments-area .comment-form .form-submit .submit {
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 15px;
  line-height: 1.8;
  border-radius: 4px;
  -webkit-user-select: none;
  user-select: none;
  transition: all 0.2s ease;
  display: inline-block;
  width: auto;
  height: auto;
}

.sp-postcomments-wrapper .comment-form .commentpolicy {
  font-size: 13px;
  margin-bottom: 10px;
}

#reply-title {
  margin-bottom: 20px;
}

@media only screen and (min-width: 480px) {
  .sp-postnavigation-wrapper .sp-postnavigation-previous-next {
    display: flex;
    justify-content: space-between;
  }
}

.sp-postnavigation-wrapper .sp-postnavigation-previous {
  overflow: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
}

.sp-postnavigation-wrapper .sp-postnavigation-next {
  overflow: hidden;
  text-align: right;
  display: flex;
  flex-direction: column;
}

.sp-postnavigation-wrapper .sp-postnavigation-previous-label,
.sp-postnavigation-wrapper .sp-postnavigation-next-label {
  overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
}

.sp-postnavigation-wrapper .sp-postnavigation-previous-title,
.sp-postnavigation-wrapper .sp-postnavigation-next-title {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  margin: 5px 30px 0;
}

.sp-postnavigation-wrapper .sp-postnavigation-previous-icon,
.sp-postnavigation-wrapper .sp-postnavigation-next-icon {
  vertical-align: middle;
  display: initial;
}

.sp-postinfo-wrapper .sp-postinfo-list-items {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
}

.sp-postinfo-wrapper .sp-postinfo-item {
  display: flex;
  align-items: flex-start;
  position: relative;
}

.sp-postinfo-wrapper .sp-postinfo-item-icon,
.sp-postinfo-wrapper .sp-postinfo-author-avatar {
  padding-right: 8px;
}

.sp-postinfo-wrapper .sp-postinfo-item .sp-postinfo-author-avatar .avatar {
  border-radius: 9999px;
  width: 24px;
  height: 24px;
}

.sp-postinfo-wrapper .sp-postinfo-term-name a {
  color: inherit !important;
}

.sp-postnavigation-shortcodes a,
.sp-postnavigation-shortcodes a:hover {
  text-decoration: none;
}

.sp-text-block-style p:not(:last-child) {
  margin-bottom: 20px;
}

.sp-text-block-style ul {
  display: block;
  list-style-type: disc;
  list-style-position: outside;
  margin: 0;
  padding: 0;
  margin-left: 2rem;
  margin-bottom: 20px;
}

.sp-text-block-style ol {
  display: block;
  list-style-position: outside;
  margin: 0;
  padding: 0;
  margin-left: 2rem;
  margin-bottom: 20px;
}

.sp-text-block-style li {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.sp-postcontent p:not(:last-child) {
  margin-bottom: 20px;
}

.sp-postcontent dl {
  margin: 0;
  padding: 0;
  margin-left: 1rem;
  margin-bottom: 20px;
}

.sp-postcontent ul {
  display: block;
  list-style-type: disc;
  list-style-position: outside;
  margin: 0;
  padding: 0;
  margin-left: 2rem;
  margin-bottom: 20px;
}

.sp-postcontent ol {
  display: block;
  list-style-position: outside;
  margin: 0;
  padding: 0;
  margin-left: 2rem;
  margin-bottom: 20px;
}

.sp-postcontent li {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.sp-postcontent img,
.sp-postcontent iframe {
  margin-bottom: 20px;
}

.sp-postcontent h1,
.sp-postcontent h2,
.sp-postcontent h3,
.sp-postcontent h4,
.sp-postcontent h5,
.sp-postcontent h6 {
  margin-bottom: 10px;
}

.sp-postcontent table {
  background-color: #f8f8f8;
}

.sp-postcontent table td,
.sp-postcontent table th {
  padding: 10px;
}

.sp-postcontent {
  clear: both;
}

.sp-postcontent .alignright {
  float: right;
  padding: 0 0 0 15px;
}

.sp-postcontent .alignleft {
  float: left;
  padding: 0 15px 0 0;
}

.sp-postcontent .aligncenter {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.sp-menu-cart-wrapper .sp-menu-cart-item-count {
  top: -0.4em;
  right: -0.9em;
  position: absolute;
  padding-left: 0.5em;
  padding-right: 0.5em;
  padding-top: 0.25em;
  padding-bottom: 0.25em;
  line-height: 1;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  border-radius: 9999px;
}

.sp-posts-single-block a,
.sp-posts-single-block a:hover {
  text-decoration: none;
}

.sp-posts-single-block {
  overflow: hidden;
}

.page-numbers {
  margin-right: 4px;
}

.blog .sp-type-archivetitle {
  display: none;
}

.widget {
  margin-bottom: 0;
}

.sp-el-section,
.sp-el-col,
.sp-el-row {
  position: relative;
}

.sp-section-shape,
.sp-row-shape,
.sp-col-shape {
  overflow: hidden;
  position: absolute;
  left: 0;
  width: 100%;
  line-height: 0;
  direction: ltr;
}

.sp-section-top,
.sp-row-top,
.sp-col-top {
  top: 0;
}

.sp-section-bottom,
.sp-row-bottom,
.sp-col-bottom {
  bottom: 0;
}

.sp-section-shape svg,
.sp-row-shape svg,
.sp-col-shape svg {
  display: block;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  position: relative;
}

.sp-section-bottom,
.sp-row-bottom,
.sp-col-bottom {
  transform: rotate(180deg);
}

.sp-section-shape .pabloo-shape-fill,
.sp-row-shape .pabloo-shape-fill,
.sp-col-shape .pabloo-shape-fill {
  fill: #fff;
}

.sp-add-to-cart-wrapper form.cart {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.sp-add-to-cart-wrapper form .qty {
  padding: 10px !important;
}

.sp-add-to-cart-wrapper form.variations_form div.single_variation_wrap {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}

.sp-add-to-cart-wrapper
  form.variations_form
  .single_variation_wrap
  .single_variation,
.sp-add-to-cart-wrapper
  form.variations_form
  .single_variation_wrap
  .single_variation
  .woocommerce-variation-description,
.sp-add-to-cart-wrapper
  form.variations_form
  .single_variation_wrap
  .single_variation
  .woocommerce-variation-price {
  margin: 10px 0;
}

.sp-add-to-cart-wrapper
  form.variations_form
  div.single_variation_wrap
  .quantity {
  float: left;
  margin-right: 0.5rem;
}

.sp-add-to-cart-wrapper form.variations_form table td {
  border: 1px solid;
  padding: 10px;
}

.sp-add-to-cart-wrapper form.variations_form table {
  border-collapse: collapse;
  background-color: inherit;
  margin: 10px 0;
  min-width: 240px;
  width: 100%;
}

.sp-not-found {
  text-align: center;
  margin: 80px 20px;
  font-size: 32px;
}

.sp-mobile-view .sp-nav-wrapper li .sp-navmenu-list-items-divider {
  display: none;
}

.sp-tablet-view .sp-nav-wrapper li .sp-navmenu-list-items-divider {
  display: none;
}

.sp-tabbedlayout-horizontal {
  display: flex;
  flex-direction: column;
}

.sp-tabbedlayout-horizontal ul li a {
  border-width: 1px;
  border-color: rgb(222 226 230 / 60%);
  border-bottom-style: none;
  cursor: pointer;
  padding: 3px 16px;
  border-bottom: 0;
}

.sp-tabbedlayout-horizontal ul li a.sp-active-tab {
  border-width: 1px;
  border-color: #dee2e6;
  border-bottom-style: none;
  background: #dee2e6;
}

.sp-tabbedlayout-horizontal .tab-content-area {
  border: 1px solid rgb(222 226 230 / 60%);
  padding: 5px 10px;
}

.sp-tabbedlayout-vertical {
  display: flex;
  flex-direction: row;
}

.sp-tabbedlayout-vertical ul li a {
  border-width: 1px;
  border-color: rgb(222 226 230 / 60%);
  cursor: pointer;
  padding: 3px 16px;
  border-right: 0;
}

.sp-tabbedlayout-vertical ul li a.sp-active-tab {
  border-width: 1px;
  border-color: #dee2e6;
  background: #eee;
}

.sp-tabbedlayout-vertical .tab-content-area {
  border: 1px solid rgb(222 226 230 / 60%);
  padding: 5px 10px;
  flex-grow: 1;
}

.sp-additional-information-wrapper
  .woocommerce-product-attributes.shop_attributes {
  width: 100%;
  border-collapse: collapse;
  background-color: unset;
}

.sp-additional-information-wrapper
  .woocommerce-product-attributes.shop_attributes
  th,
.sp-additional-information-wrapper
  .woocommerce-product-attributes.shop_attributes
  td {
  border: 1px solid #000;
  padding: 10px;
}

.woocommerce a.button {
  font-size: 100%;
  margin: 0;
  line-height: 1;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  overflow: visible;
  padding: 0.618em 1em;
  font-weight: 700;
  border-radius: 3px;
  left: auto;
  color: #515151;
  background-color: #ebe9eb;
  border: 0;
  display: inline-block;
  background-image: none;
  box-shadow: none;
  text-shadow: none;
}

.sp-upsells-wrapper .up-sells ul.products,
.sp-product-related-wrapper .related ul.products {
  list-style: none;
}

.sp-upsells-wrapper .up-sells .onsale,
.sp-product-related-wrapper .related .onsale {
  min-width: 50px !important;
  min-height: 50px !important;
  font-size: 13px;
}

.sp-product-rating-wrapper .woocommerce.woocommerce-product-rating {
  margin: 0;
  align-items: center;
  display: flex;
}

.sp-product-data-tabs-wrapper .woocommerce-tabs ul.tabs li {
  display: inline-flex !important;
  /*display: -webkit-inline-box !important;*/
  margin: 0;
}

.sp-product-data-tabs-wrapper .woocommerce-tabs ul.tabs li a {
  padding: 10px 10px;
}

.sp-product-data-tabs-wrapper .woocommerce-tabs ul li.active a {
  box-shadow: none;
}

.sp-product-data-tabs-wrapper .woocommerce-tabs #tab-reviews #submit {
  float: none;
}

.wc-tabs li {
  background: #f8f8f8;
  padding: 6px;
}

.wc-tabs li.active {
  background: #f7f6f7;
}

.wc-tabs {
  margin-bottom: 10px;
}

.woocommerce-order-details h2,
.woocommerce-customer-details h2 {
  margin-bottom: 10px;
}

.nav-menu-bar li.separator:last-child {
  display: none;
}

.sp-divider-wrapper .sp-divider.sp-divider-with-icon {
  display: flex;
}

.sp-divider-wrapper .sp-divider .sp-divider-separator {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
}

.sp-divider-wrapper .sp-divider .sp-divider-separator::after,
.sp-divider-wrapper .sp-divider .sp-divider-separator::before {
  flex-grow: 1;
  -webkit-box-flex: 1;
}

.sp-divider-wrapper .sp-divider .sp-divider-text-block {
  padding: 0 10px;
}

.sp-divider-wrapper .sp-divider .sp-divider-text-block .sp-divider-text {
  font-size: 15px;
}

.sp_animated_start {
  opacity: 0;
}

.sp-counter-wrapper {
  flex-direction: column;
}

.sp-counter-wrapper .sp-counter-title,
.sp-counter-wrapper .sp-counter-text-wrapper {
  display: flex;
}

.sp-counter-wrapper .sp-counter-text-wrapper .sp-counter-number-prefix,
.sp-counter-wrapper .sp-counter-text-wrapper .sp-counter-number-suffix {
  white-space: pre-wrap;
}

.sp-hotspot-wrapper {
  position: relative;
}

.hotspot-wrapper {
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.hotspot-repeater-item {
  left: 50%;
  --hotspot-translate-x: 50%;
  top: 50%;
  --hotspot-translate-y: 50%;
}

.hotspot-item-inner-circle {
  border-radius: 50%;
  top: 50%;
  left: 50%;
  padding: 10px;
}

.hotspot-soft-beat {
  animation-duration: 0.7s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: hotspot-soft-beat;
}

.hotspot-expand {
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: hotspot-expand;
}

@keyframes hotspot-soft-beat {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.1);
  }
}

@keyframes hotspot-expand {
  from {
    transform: scale(0.5);
    opacity: 1;
  }

  to {
    transform: scale(1);
    opacity: 0.7;
  }
}

.sp-content-toggle-area input[type="checkbox"] {
  position: relative;
  width: 80px;
  height: 40px;
  appearance: none;
  background: silver;
  outline: 0;
  border-radius: 2rem;
  cursor: pointer;
  box-shadow: inset 0 0 5px rgb(0 0 0 / 50%);
}

.sp-content-toggle-area input[type="checkbox"]::before {
  content: "";
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  transition: 0.5s;
}

.sp-content-toggle-area.sp-square input[type="checkbox"] {
  border-radius: 0;
}

.sp-content-toggle-area.sp-square input[type="checkbox"]::before {
  border-radius: 0;
}

.sp-content-toggle-area.sp-label input[type="checkbox"] {
  border-radius: 0;
}

.sp-content-toggle-area.sp-label input[type="checkbox"]:checked::before {
  content: "ON";
  display: flex;
  justify-content: center;
  align-items: center;
}

.sp-content-toggle-area.sp-label input[type="checkbox"]::before {
  border-radius: 0;
  content: "OFF";
  display: flex;
  justify-content: center;
  align-items: center;
}

.sp-content-toggle-area input[type="checkbox"]:checked::before {
  transform: translateX(100%);
  background: #fff;
}

.sp-content-toggle-area input[type="checkbox"]:checked {
  background: #696969;
}

.sp-contenttoggle-size-large .sp-content-toggle-area input[type="checkbox"] {
  width: 100px;
  height: 50px;
}

.sp-contenttoggle-size-large
  .sp-content-toggle-area
  input[type="checkbox"]::before {
  width: 50px;
  height: 50px;
}

.sp-contenttoggle-size-small .sp-content-toggle-area input[type="checkbox"] {
  width: 60px;
  height: 30px;
}

.sp-contenttoggle-size-small
  .sp-content-toggle-area
  input[type="checkbox"]::before {
  width: 30px;
  height: 30px;
}

.sp-contenttoggle-size-small
  .sp-content-toggle-area.sp-label
  input[type="checkbox"]::before {
  font-size: 12px;
}

.sp-contenttoggle-size-mini .sp-content-toggle-area input[type="checkbox"] {
  width: 40px;
  height: 20px;
}

.sp-contenttoggle-size-mini
  .sp-content-toggle-area
  input[type="checkbox"]::before {
  width: 20px;
  height: 20px;
}

.sp-contenttoggle-size-mini
  .sp-content-toggle-area.sp-label
  input[type="checkbox"]::before {
  font-size: 10px;
}

.post-password-form {
  align-items: center;
  flex-direction: column;
  display: flex;
}

.post-password-form p {
  padding: 1rem;
}

.post-password-form p input[type="submit"] {
  padding: 10px;
  cursor: pointer;
}

.sp-alert-info {
  background: #e1effe;
  color: #1a56db;
  border-color: #1a56db;
}

.sp-alert-success {
  background: #def7ec;
  color: #046c4e;
  border-color: #046c4e;
}

.sp-alert-warning {
  background: #fdf6b2;
  color: #8e4b10;
  border-color: #8e4b10;
}

.sp-alert-danger {
  background: #fde8e8;
  color: #c81e1e;
  border-color: #c81e1e;
}

.sp-alert-style-style1 {
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.sp-alert-style-style2 {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-width: 4px;
}

.sp-alert-style-style3 {
  border-left-width: 4px;
}

.sp-alert-style-style4 {
  border-width: 1px;
  border-radius: 15px;
}

.sp-alert-style-style4 .sp-alert-block-title-block {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.sp-alert-style-style3 .sp-alert-block-title,
.sp-alert-style-style3 .sp-alert-block-title-block {
  padding-bottom: 0;
}

.sp-alert-style-style1 .sp-alert-block-title-block,
.sp-alert-style-style2 .sp-alert-block-title-block {
  padding-bottom: 0;
}

.sp-alert-close {
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 3px;
  font-size: 20px;
  line-height: 1;
  background: transparent;
  color: inherit;
  border: 0;
  cursor: pointer;
}

.sp-alert-close:focus {
  outline: 0;
}

.sp-type-alert {
  position: relative;
}

.pabloo-business-review-wrapper {
  padding-right: calc(25px / 2);
  padding-left: calc(25px / 2);
  margin-bottom: 25px;
  text-align: center;
}

.pabloo-business-review-image {
  width: 60px;
  height: 60px;
  display: inline-block;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
}

.sp-busines-review-block-preview.review-display-grid.review-grid_column-1
  .pabloo-business-review-wrapper,
.sp-busines-review-block-preview.review-display-carousel.review-carousel-1
  .pabloo-business-review-wrapper {
  width: 100%;
}

.sp-busines-review-block-preview.review-display-grid.review-grid_column-2
  .pabloo-business-review-wrapper,
.sp-busines-review-block-preview.review-display-carousel.review-carousel-2
  .pabloo-business-review-wrapper {
  width: 50%;
}

.sp-busines-review-block-preview.review-display-grid.review-grid_column-3
  .pabloo-business-review-wrapper,
.sp-busines-review-block-preview.review-display-carousel.review-carousel-3
  .pabloo-business-review-wrapper {
  width: 33.33%;
}

.sp-busines-review-block-preview.review-display-grid.review-grid_column-4
  .pabloo-business-review-wrapper,
.sp-busines-review-block-preview.review-display-carousel.review-carousel-4
  .pabloo-business-review-wrapper {
  width: 25%;
}

.sp-busines-review-block-preview.review-display-grid.review-grid_column-5
  .pabloo-business-review-wrapper,
.sp-busines-review-block-preview.review-display-carousel.review-carousel-5
  .pabloo-business-review-wrapper {
  width: 20%;
}

.sp-busines-review-block-preview.review-display-grid
  .pabloo-business-reviews-block {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.sp-busines-review-block-preview.review-display-carousel
  .pabloo-business-reviews-block {
  display: flex;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  text-align: left;
  z-index: 0;
}

.fa-star-yellow {
  color: #f29b2c;
}

.fa-star-gray {
  color: #aab2ba;
}

@media only screen and (max-width: 786px) {
  .pabloo-business-review-wrapper {
    padding-right: calc(10px / 2);
    padding-left: calc(10px / 2);
    margin-bottom: 10px;
    text-align: center;
  }
}

.sp-particle-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sp-product-gallery-images-shortcode .woocommerce-product-gallery {
  position: relative;
  margin-bottom: 2.617924em;
  margin-top: 0;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .woocommerce-product-gallery__trigger {
  position: absolute;
  top: 0.875em;
  right: 0.875em;
  display: block;
  height: 2em;
  width: 2em;
  border-radius: 3px;
  z-index: 99;
  text-align: center;
  text-indent: -999px;
  overflow: hidden;
  text-decoration: none;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .woocommerce-product-gallery__trigger::before {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  line-height: inherit;
  vertical-align: baseline;
  content: "ï€Ž";
  display: block;
  line-height: 2;
  text-indent: 0;
  text-decoration: none;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .flex-control-thumbs {
  margin: 0;
  padding: 0;
  list-style: decimal;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .flex-viewport {
  margin-bottom: 1.618em;
}

.sp-product-gallery-images-shortcode .woocommerce-product-gallery .zoomImg {
  background-color: #fff;
}

.sp-product-gallery-images-shortcode .woocommerce-product-gallery img {
  width: 100%;
  height: auto;
  box-shadow: none;
  margin: 0;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .flex-control-thumbs {
  margin: 0;
  padding: 0;
  display: flow-root;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery.woocommerce-product-gallery--columns-4
  .flex-control-thumbs
  li:nth-child(4n) {
  margin-right: 0;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .flex-control-thumbs::before,
.woocommerce-product-gallery .flex-control-thumbs::after {
  content: "";
  display: table;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .flex-control-thumbs
  li
  img {
  opacity: 0.5;
  transition: all, ease, 0.2s;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .flex-control-thumbs
  li
  img.flex-active {
  opacity: 1;
}

.sp-product-gallery-images-shortcode
  .woocommerce-product-gallery
  .flex-control-thumbs
  li {
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
  width: 14.2857142857%;
  float: left;
  margin-right: 14.2857142857%;
}

#edd_purchase_form_wrap .edd-submit {
  margin-top: 10px;
}

#edd_checkout_wrap table#edd_checkout_cart {
  border-collapse: collapse !important;
}

#edd_checkout_wrap input[type="number"],
#edd_checkout_wrap input[type="tel"],
#edd_checkout_wrap input[type="text"],
#edd_checkout_wrap input[type="password"],
#edd_checkout_wrap input[type="email"],
#edd_checkout_wrap select,
#edd_checkout_wrap textarea,
.select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  padding: 10px;
}

#edd_checkout_wrap #edd_final_total_wrap {
  margin-bottom: 10px;
}

.edd_downloads_list .edd_go_to_checkout {
  margin-top: 10px;
}

.edd_downloads_list .edd_download div.edd_download_image {
  margin-bottom: 1rem;
}

.edd_downloads_list .edd_download .edd_download_title {
  margin-bottom: 1rem;
}

.edd_downloads_list .edd_download div.edd_download_full_content {
  margin-bottom: 1rem;
}

.edd_downloads_list .edd_download div.edd_price {
  margin-bottom: 1rem;
}

.edd_downloads_list .edd_download div.edd_download_buy_button {
  margin-bottom: 1rem;
}

.edd_downloads_list .edd_download div.edd_download_excerpt {
  margin-bottom: 1rem;
}

.edd_downloads_list .edd_download .edd_download_quantity_wrapper {
  margin-bottom: 1rem;
}

.sp-edd-cart-wrapper .edd-cart-number-of-items {
  margin-bottom: 10px;
  padding: 10px;
}

.sp-edd-cart-wrapper ul.edd-cart {
  list-style: none;
  padding: 10px;
}

.sp-edd-cart-wrapper li.edd-cart-item {
  text-align: end;
}

.sp-edd-cart-wrapper li span.edd-cart-item-title {
  float: left;
}

.sp-edd-cart-wrapper .edd-cart-item .edd-cart-item-separator {
  display: none !important;
}

.sp-edd-cart-wrapper li.edd-cart-meta.edd_total {
  margin-bottom: 1rem;
  text-align: right;
}

.sp-edd-cart-wrapper li.cart_item.edd_checkout a.sp-button {
  padding: 6px 12px;
}

.sp-edd-cart-wrapper ul.edd-cart li:not(.edd_checkout) {
  padding: 1rem;
}

.sp-edd-cart-wrapper li.cart_item.edd_checkout {
  margin-bottom: 1rem;
}

.edd_download_purchase_form input[type="number"],
.edd_download_purchase_form input[type="tel"],
.edd_download_purchase_form input[type="text"],
.edd_download_purchase_form input[type="password"],
.edd_download_purchase_form input[type="email"],
.edd_download_purchase_form select {
  padding: 10px;
}

.sp-video-pop-up-block .sp-video-wrapper .sp-video-responsive,
.sp-video-pop-up-block .sp-video-responsive-video {
  height: 100%;
  width: 100%;
}

.sp-video-pop-up-block .sp-video-wrapper .sp-video-responsive-video video {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.sp-video-pop-up-block .sp-video-responsive-video {
  overflow: hidden;
  position: relative;
}

.sp-video-pop-up-block .sp-video-wrapper-sticky {
  height: 500px;
}

.sp-video-pop-up-block .sp-video-responsive-sticky {
  position: fixed;
  right: 15px;
  bottom: 15px;
  max-width: 550px;
  width: 500px;
  z-index: 9999;
}

.sp-video-pop-up-block .sp-video-pop-up-banner-sticky {
  position: fixed;
  right: 15px;
  bottom: 330px;
  max-width: 550px;
  width: 500px;
  z-index: 9999;
}

.sp-video-pop-up-block .sp-video-pop-up-banner-custom-sticky {
  position: fixed;
  right: 15px;
  bottom: 295px;
  max-width: 550px;
  width: 500px;
  z-index: 9999;
}

.sp-video-pop-up-block .sp-video-pop-up-banner-vimeo-sticky {
  position: fixed;
  right: 15px;
  bottom: 315px;
  max-width: 550px;
  width: 500px;
  z-index: 9999;
}

.sp-video-pop-up-block .sp-video-pop-up-banner {
  width: 100%;
}

.sp-video-pop-up-block .sp-video-pop-up-banner-text {
  padding: 5px;
}

.sp-video-pop-up-block .sp-video-responsive-sticky iframe,
.sp-video-pop-up-block .sp-video-responsive-sticky video {
  position: fixed !important;
  right: 15px;
  bottom: 15px;
  max-width: 550px;
  width: 500px;
}

.sp-video-pop-up-block .sp-video-wrapper a.sp-video-responsive {
  display: block !important;
  color: inherit !important;
}

.sp-video-pop-up-block .sp-video-pop-up-placeholder {
  display: none !important;
}

.sp-video-pop-up-block .sp-video-pop-up-overlay-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50%;
  cursor: pointer;
}

.sp-video-pop-up-block .sp-video-pop-up-overlay-play-icon-display {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.sp-video-pop-up-block .sp-video-pop-up-teaser-video-play-icon-display {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.sp-video-pop-up-block .sp-video-pop-up-teaser-video-play-icon-display i {
  cursor: pointer;
}

.sp-video-pop-up-block .video-pop-up-modal {
  display: none;
  position: fixed;
  z-index: 9999;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
}

.sp-video-pop-up-block .video-pop-up-modal .modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  padding: 0;
  width: 90%;
  max-width: 1200px;
}

.sp-video-pop-up-block .video-pop-up-modal .close {
  color: white;
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 35px;
  font-weight: bold;
}

.sp-video-pop-up-block .video-pop-up-modal .close:hover,
.sp-video-pop-up-block .video-pop-up-modal .close:focus {
  color: #999;
  text-decoration: none;
  cursor: pointer;
}

.sp-skin-card .sp-posts-single-block {
  display: flex;
  position: relative;
  flex-direction: column;
}

.sp-skin-card .sp-posts-single-block .sp-container-badge {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.1em 1.2em;
  background: black;
  margin: 10px;
  color: #fff;
  border-radius: 15px;
}

.sp-skin-card .sp-posts-single-block .sp-container-avatar {
  position: relative;
  padding: 0 30px;
  width: 100%;
  top: -25px;
  height: 0;
  pointer-events: none;
}

.sp-posts-inner-block .sp-container.sp-mb-5 {
  margin-bottom: 1.25rem;
}

.sp-skin-card .sp-posts-single-block .sp-container-avatar img {
  border-radius: 50%;
  width: 60px;
  pointer-events: all;
  transform: translateY(-50%);
}

.sp-skin-card .sp-posts-single-block {
  background: #fff;
}

.sp-skin-card .post-text-container {
  flex-grow: 1;
}

.sp-skin-card.sp-post-masonary-true {
  align-items: flex-start;
}

.sp-skin-card.sp-post-masonary-true .sp-posts-single-block {
  padding-right: calc(20px / 2);
  padding-left: calc(20px / 2);
  margin-bottom: 20px;
}

.sp-skin-card .sp-posts-single-block .sp-posts-inner-block {
  display: flex;
  flex-direction: column;
}

.sp-columns-1.sp-post-masonary-true .sp-posts-single-block {
  width: 100%;
}

.sp-columns-2.sp-post-masonary-true .sp-posts-single-block {
  width: 50%;
}

.sp-columns-3.sp-post-masonary-true .sp-posts-single-block {
  width: 33.33%;
}

.sp-columns-4.sp-post-masonary-true .sp-posts-single-block {
  width: 25%;
}

.sp-columns-5.sp-post-masonary-true .sp-posts-single-block {
  width: 20%;
}

.sp-grid-cols-1.sp-post-masonary-true .sp-posts-single-block {
  width: 100%;
}

.sp-grid-cols-2.sp-post-masonary-true .sp-posts-single-block {
  width: 50%;
}

.sp-grid-cols-3.sp-post-masonary-true .sp-posts-single-block {
  width: 33.33%;
}

.sp-grid-cols-4.sp-post-masonary-true .sp-posts-single-block {
  width: 25%;
}

.sp-grid-cols-5.sp-post-masonary-true .sp-posts-single-block {
  width: 20%;
}

.sp-post-masonary-true {
  flex-wrap: wrap;
}

.sp-layout-masonary {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.sp-layout-masonary .pabloo-masonary-post-block {
  display: flex;
  flex-wrap: wrap;
}

.sp-post-masonary-true:after {
  content: "";
  display: block;
  clear: both;
}

.sp-creative-posts .sp-posts-inner-block {
  display: flex;
  position: relative;
  flex-direction: row;
}

.sp-creative-posts .sp-posts-inner-block .sp-thumbnail {
  width: calc(100% - 50%);
}

.sp-creative-posts .sp-posts-inner-block.post_no_image {
  padding: 30px 5px;
}

.sp-creative-posts .sp-posts-inner-block.post_no_image .sp-post-text-container {
  width: 100%;
}

.sp-posts-single-block .sp-container-badge {
  padding: 4px 10px;
}

.sp-creative-posts .sp-posts-inner-block.sp-right-side-image {
  flex-direction: row-reverse;
}

.sp-creative-posts
  .sp-posts-inner-block.sp-left-side-image:not(.post_no_image)
  .sp-post-text-container {
  margin-left: -30px;
}

.sp-creative-posts
  .sp-posts-inner-block.sp-right-side-image:not(.post_no_image)
  .sp-post-text-container {
  margin-right: -30px;
}

.sp-creative-posts
  .sp-posts-inner-block:not(.post_no_image)
  .sp-post-text-container {
  width: calc(50% + 25px);
  margin-top: 30px;
  margin-bottom: 30px;
}

.sp-creative-posts .sp-posts-inner-block .sp-post-text-container {
  background-color: #fff;
  padding: 30px 30px 30px 30px;
  box-shadow: 0 1px 25px rgba(0, 0, 0, 0.05);
  z-index: 1;
}

.sp-skin-minimal .sp-posts-single-block.sp-minimal-posts:first-child {
  border-top: 0;
}

.sp-skin-minimal .sp-posts-single-block.sp-minimal-posts {
  padding: 1rem 2px;
  margin: 0;
}

.sp-skin-minimal.sp-layout-masonary .sp-posts-single-block.sp-minimal-posts {
  padding: 1rem 6px;
}

.sp-minimal-posts .sp-posts-inner-block {
  display: flex;
  position: relative;
  flex-direction: row;
}

.sp-minimal-posts .sp-posts-inner-block .sp-thumbnail {
  width: calc(100% - 70%);
}

.sp-minimal-posts .sp-posts-inner-block.post_no_image .sp-post-text-container {
  width: 100%;
}

.sp-minimal-posts .sp-posts-inner-block.sp-right-side-image {
  flex-direction: row-reverse;
}

.sp-minimal-posts
  .sp-posts-inner-block.sp-left-side-image:not(.post_no_image)
  .sp-post-text-container {
  margin-left: 0;
}

.sp-minimal-posts
  .sp-posts-inner-block.sp-right-side-image:not(.post_no_image)
  .sp-post-text-container {
  margin-right: 0;
}

.sp-minimal-posts
  .sp-posts-inner-block:not(.post_no_image)
  .sp-post-text-container {
  width: 70%;
}

.sp-minimal-posts .sp-posts-inner-block .sp-post-text-container {
  padding: 20px 20px 20px 20px;
  z-index: 1;
}

.sp-minimal-posts .sp-thumbnail {
  border-radius: 15px;
}

.sp-news-posts .sp-featured-image {
  margin-bottom: 5px;
}

.sp-layout-gridlayout.sp-skin-news.sp-gap-4 {
  grid-gap: 0;
  gap: 0;
}

.sp-posts-single-block.sp-news-posts:first-child {
  border-left: 0;
}

.sp-posts-single-block.sp-news-posts {
  border-left: 1px solid;
  padding: 0 1rem;
  margin-bottom: 10px;
}

.pabloo-carousel-post-block .sp-posts-single-block.sp-card-posts,
.sp-skin-minimal
  .pabloo-carousel-post-block
  .sp-posts-single-block.sp-minimal-posts {
  margin: 0 10px;
}

.pabloo-carousel-post-block .sp-posts-single-block {
  margin: 0 10px;
}

.sp-layout-gridlayout.sp-skin-minimal.sp-gap-4 {
  grid-gap: 0;
  gap: 0;
}

.sp-layout-gridlayout .sp-posts-single-block.sp-minimal-posts {
  margin: 0 10px;
}

.sp-featured-image .sp-posts-image-link,
.sp-featured-image .sp-posts-image-link img {
  width: 100%;
}

.sp-posts-block-wrapper .sp-layout-carousel {
  display: flex;
  flex-direction: column;
}

.sp-posts-block-wrapper .pabloo-carousel-post-block {
  display: flex;
}

.sp-layout-masonary {
  grid-gap: 1rem;
  gap: 1rem;
  row-gap: 1rem;
}

.sp-layout-masonary .sp-posts-single-block {
  padding: 5px;
  margin-bottom: 0.5rem;
}

.sp-grid-cols-1.sp-layout-masonary .sp-posts-single-block {
  width: 100%;
}

.sp-grid-cols-2.sp-layout-masonary .sp-posts-single-block {
  width: calc(50% - 1rem);
  margin: 0.5rem;
}

.sp-grid-cols-3.sp-layout-masonary .sp-posts-single-block {
  width: calc(33.33% - 1rem);
  margin: 0.5rem;
}

.sp-grid-cols-4.sp-layout-masonary .sp-posts-single-block {
  width: calc(25% - 1rem);
  margin: 0.5rem;
}

.sp-grid-cols-5.sp-layout-masonary .sp-posts-single-block {
  width: calc(20% - 1rem);
  margin: 0.5rem;
}

.sp-grid-cols-1.pabloo-carousel-post-block .sp-posts-single-block {
  width: 100%;
}

.sp-grid-cols-2.pabloo-carousel-post-block .sp-posts-single-block {
  width: 50%;
}

.sp-grid-cols-3.pabloo-carousel-post-block .sp-posts-single-block {
  width: 33.33%;
}

.sp-grid-cols-4.pabloo-carousel-post-block .sp-posts-single-block {
  width: 25%;
}

.sp-grid-cols-5.pabloo-carousel-post-block .sp-posts-single-block {
  width: 20%;
}

.sp-gap-4 .pabloo-carousel-post-block {
  grid-gap: 0;
  gap: 0;
}

.sp-layout-carousel .sp-posts-single-block.show-carousel-area {
  transition: opacity 0.3s linear 0s;
  opacity: 1;
  z-index: 999;
}

.sp-layout-carousel .sp-posts-single-block.hidden-carousel-area {
  opacity: 0;
  position: absolute;
}

.sp-layout-masonary .sp-posts-single-block.sp-news-posts {
  border-left: 0;
}

.sp-skin-block .sp-posts-image img {
  width: 100%;
}

.pabloo-carousel-post-block .sp-posts-single-block.sp-minimal-posts,
.sp-layout-masonary .sp-posts-single-block.sp-minimal-posts {
  border-top: 0;
}

.woocommerce-page
  .widget-content-block
  .select2-container
  .select2-search__field,
.woocommerce-page .select2-container .select2-selection {
  height: auto;
}

.woocommerce-page
  .widget-content-block
  .select2-container
  .select2-selection.select2-selection--single {
  min-height: 60px;
  padding-top: 5px;
  padding-bottom: 5px;
}

@media screen and (max-width: 768px) {
  .image-preview-container #preview-image,
  .image-preview-container #preview-image {
    width: auto !important;
    height: auto !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    object-fit: contain !important;
  }
}

@media (min-width: 640px) {
  .sm\\:sp-flex {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/hero-pablooprod/normalize.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;EAOE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;2DAEyD;EACzD,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAcA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;;EAGE,UAAU;EACV,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE;aACW;AACb;;AAEA;;;;;;EAME,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAiBA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,yDAAgP;EAGhP,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EAGE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EAGzB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yDAA0P;EAC1P,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;;2DAEyD;AAC3D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;EAgBE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAGE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;;;;;;;;;GASC;EACD,0BAA0B;AAC5B;;AAEA;EACE;;;;;;;;;GASC;EACD,0BAA0B;EAE1B,kDAAkD;AACpD;;AAYA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAYA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EAEE,6CAA6C;AAC/C;;AAEA;EACE;;;;;;;;;cASY;EACZ,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,YAAY;EACd;;AAEF;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;;IAIE,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE;;;;;;;MAOE,2BAA2B;IAC7B;EACF;;EAEA;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,mCAAmC;EACnC,4BAA4B;EAC5B,IAAI;;EAEJ;;;;;;IAME,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,MAAM;EACN,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;;;IAGE,WAAW;IACX,yBAAyB;IACzB,OAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,OAAO;IACP,SAAS;IACT,cAAc;EAChB;;EAEA;;;IAGE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;;;IAGE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IAEE,wCAAwC;EAC1C;;EAEA;IAEE,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,mFAAmF;AACnF;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;;;EAGE,MAAM;AACR;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,SAAS;EAET,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;EAIE,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;EAcE,cAAc;AAChB;;AAEA;;;;EAIE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;;;;;EAME,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EAEE,wBAAwB;EAExB,+BAA+B;EAE/B,mBAAmB;EAEnB,mCAAmC;EAEnC,8BAA8B;EAE9B,yBAAyB;EAEzB,6BAA6B;EAE7B,iCAAiC;AACnC;;AAEA;EAEE,wBAAwB;EAExB,+BAA+B;EAE/B,mBAAmB;EAEnB,mCAAmC;EAEnC,2BAA2B;EAE3B,yBAAyB;EAEzB,6BAA6B;EAE7B,8BAA8B;AAChC;;AAcA;EACE;IAEE,mBAAmB;EACrB;;EAEA;IAEE,qBAAqB;EACvB;AACF;;AAgBA;EACE;IAEE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IAEE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EAGZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EAEE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,cAAc;AAChB;;AAEA;;;;;EAKE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;;;;;;EAUE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EAEX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kBAAkB;EAElB,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kBAAkB;EAElB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAET,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EAEnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,kCAAkC;EAClC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;EAIE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;IAEpB,2CAA2C;IAE3C,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\nhtml {\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n}\n\nmain {\n  display: block;\n}\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\npre {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\na {\n  background-color: transparent;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\ncode {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nimg {\n  border-style: none;\n}\n\nbutton,\ninput,\nselect {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\nlegend {\n  box-sizing: border-box;\n  color: inherit;\n  display: table;\n  max-width: 100%;\n  padding: 0;\n  white-space: normal;\n}\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\n\nsummary {\n  display: list-item;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none;\n}\n\nh1,\nh2,\nh3,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nbutton {\n  background-color: transparent;\n  background-image: none;\n  padding: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  line-height: 1.5;\n}\n\n*,\n::before,\n::after {\n  box-sizing: border-box;\n  border-width: 0;\n  border-style: solid;\n  border-color: #e2e8f0;\n}\n\nhr {\n  border-top-width: 1px;\n}\n\nimg {\n  border-style: solid;\n}\n\ninput::-webkit-input-placeholder {\n  color: #a0aec0;\n}\n\ninput:-ms-input-placeholder {\n  color: #a0aec0;\n}\n\ninput::-ms-input-placeholder {\n  color: #a0aec0;\n}\n\ninput::placeholder {\n  color: #a0aec0;\n}\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nh1,\nh2,\nh3 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\nbutton,\ninput,\nselect {\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n}\n\npre,\ncode {\n  font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\",\n    monospace;\n}\n\nimg,\nsvg,\nvideo,\ncanvas,\niframe,\nembed {\n  display: block;\n  vertical-align: middle;\n}\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n.sp-form-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  border-color: #e2e8f0;\n  border-width: 1px;\n  border-radius: 0.25rem;\n  padding-top: 0.5rem;\n  padding-right: 0.75rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.sp-form-input::-webkit-input-placeholder {\n  color: #a0aec0;\n  opacity: 1;\n}\n\n.sp-form-input:-ms-input-placeholder {\n  color: #a0aec0;\n  opacity: 1;\n}\n\n.sp-form-input::-ms-input-placeholder {\n  color: #a0aec0;\n  opacity: 1;\n}\n\n.sp-form-input::placeholder {\n  color: #a0aec0;\n  opacity: 1;\n}\n\n.sp-form-input:focus {\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  border-color: #63b3ed;\n}\n\n.sp-form-select {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23a0aec0'%3e%3cpath d='M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z'/%3e%3c/svg%3e\");\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  background-repeat: no-repeat;\n  background-color: #fff;\n  border-color: #e2e8f0;\n  border-width: 1px;\n  border-radius: 0.25rem;\n  padding-top: 0.5rem;\n  padding-right: 2.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  background-position: right 0.5rem center;\n  background-size: 1.5em 1.5em;\n}\n\n.sp-form-select::-ms-expand {\n  color: #a0aec0;\n  border: 0;\n}\n\n@media not print {\n  .sp-form-select::-ms-expand {\n    display: none;\n  }\n}\n\n@media print and (-ms-high-contrast: active),\n  print and (-ms-high-contrast: none) {\n  .sp-form-select {\n    padding-right: 0.75rem;\n  }\n}\n\n.sp-form-select:focus {\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  border-color: #63b3ed;\n}\n\n.sp-form-checkbox {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  display: inline-block;\n  vertical-align: middle;\n  background-origin: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  flex-shrink: 0;\n  height: 1em;\n  width: 1em;\n  color: #4299e1;\n  background-color: #fff;\n  border-color: #e2e8f0;\n  border-width: 1px;\n  border-radius: 0.25rem;\n}\n\n.sp-form-checkbox:checked {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e\");\n  border-color: transparent;\n  background-color: currentColor;\n  background-size: 100% 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n@media not print {\n  .sp-form-checkbox::-ms-check {\n    border-width: 1px;\n    color: transparent;\n    background: inherit;\n    border-color: inherit;\n    border-radius: inherit;\n  }\n}\n\n.sp-form-checkbox:focus {\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  border-color: #63b3ed;\n}\n\n.sp-bg-black {\n  background-color: #000;\n}\n\n.sp-bg-white {\n  background-color: #fff;\n}\n\n.sp-bg-blue-500 {\n  background-color: #4299e1;\n}\n\n.hover\\:sp-bg-blue-700:hover {\n  background-color: #2b6cb0;\n}\n\n.sp-rounded {\n  border-radius: 0.25rem;\n}\n\n.sp-rounded-md {\n  border-radius: 0.375rem;\n}\n\n.sp-rounded-full {\n  border-radius: 9999px;\n}\n\n.sp-rounded-r {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.sp-rounded-l {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.sp-rounded-bl {\n  border-bottom-left-radius: 0.25rem;\n}\n\n.sp-border-dotted {\n  border-style: dotted;\n}\n\n.sp-border-none {\n  border-style: none;\n}\n\n.sp-border-2 {\n  border-width: 2px;\n}\n\n.sp-border {\n  border-width: 1px;\n}\n\n.sp-cursor-pointer {\n  cursor: pointer;\n}\n\n.sp-cursor-move {\n  cursor: move;\n}\n\n.sp-block {\n  display: block;\n}\n\n.sp-inline-block {\n  display: inline-block;\n}\n\n.sp-inline {\n  display: inline;\n}\n\n.sp-flex {\n  display: flex;\n}\n\n.sp-inline-flex {\n  display: inline-flex;\n}\n\n.sp-hidden {\n  display: none;\n}\n\n.sp-flex-row {\n  flex-direction: row;\n}\n\n.sp-flex-row-reverse {\n  flex-direction: row-reverse;\n}\n\n.sp-flex-col {\n  flex-direction: column;\n}\n\n.sp-flex-wrap {\n  flex-wrap: wrap;\n}\n\n.sp-items-start {\n  align-items: flex-start;\n}\n\n.sp-items-end {\n  align-items: flex-end;\n}\n\n.sp-items-center {\n  align-items: center;\n}\n\n.sp-items-baseline {\n  align-items: baseline;\n}\n\n.sp-items-stretch {\n  align-items: stretch;\n}\n\n.sp-self-start {\n  align-self: flex-start;\n}\n\n.sp-self-center {\n  align-self: center;\n}\n\n.sp-justify-start {\n  justify-content: flex-start;\n}\n\n.sp-justify-end {\n  justify-content: flex-end;\n}\n\n.sp-justify-center {\n  justify-content: center;\n}\n\n.sp-justify-between {\n  justify-content: space-between;\n}\n\n.sp-justify-around {\n  justify-content: space-around;\n}\n\n.sp-justify-evenly {\n  justify-content: space-evenly;\n}\n\n.sp-font-sans {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n\n.sp-font-semibold {\n  font-weight: 600;\n}\n\n.sp-font-bold {\n  font-weight: 700;\n}\n\n.sp-h-3 {\n  height: 0.75rem;\n}\n\n.sp-h-4 {\n  height: 1rem;\n}\n\n.sp-h-6 {\n  height: 1.5rem;\n}\n\n.sp-h-8 {\n  height: 2rem;\n}\n\n.sp-h-full {\n  height: 100%;\n}\n\n.sp-leading-none {\n  line-height: 1;\n}\n\n.sp-m-2 {\n  margin: 0.5rem;\n}\n\n.sp-m-auto {\n  margin: auto;\n}\n\n.sp-mx-1 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.sp-mx-4 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.sp-my-8 {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.sp-mt-1 {\n  margin-top: 0.25rem;\n}\n\n.sp-mr-1 {\n  margin-right: 0.25rem;\n}\n\n.sp-mb-1 {\n  margin-bottom: 0.25rem;\n}\n\n.sp-mt-2 {\n  margin-top: 0.5rem;\n}\n\n.sp-mr-2 {\n  margin-right: 0.5rem;\n}\n\n.sp-mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.sp-ml-2 {\n  margin-left: 0.5rem;\n}\n\n.sp-mt-3 {\n  margin-top: 0.75rem;\n}\n\n.sp-mb-3 {\n  margin-bottom: 0.75rem;\n}\n\n.sp-ml-3 {\n  margin-left: 0.75rem;\n}\n\n.sp-mt-4 {\n  margin-top: 1rem;\n}\n\n.sp-mr-4 {\n  margin-right: 1rem;\n}\n\n.sp-mb-4 {\n  margin-bottom: 1rem;\n}\n\n.sp-ml-4 {\n  margin-left: 1rem;\n}\n\n.sp-mr-6 {\n  margin-right: 1.5rem;\n}\n\n.sp-mb-6 {\n  margin-bottom: 1.5rem;\n}\n\n.sp-ml-6 {\n  margin-left: 1.5rem;\n}\n\n.sp-mt-8 {\n  margin-top: 2rem;\n}\n\n.sp-object-cover {\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.sp-opacity-25 {\n  opacity: 0.25;\n}\n\n.sp-opacity-50 {\n  opacity: 0.5;\n}\n\n.sp-opacity-75 {\n  opacity: 0.75;\n}\n\n.sp-outline-none {\n  outline: 0;\n}\n\n.focus\\:sp-outline-none:focus {\n  outline: 0;\n}\n\n.sp-p-1 {\n  padding: 0.25rem;\n}\n\n.sp-p-3 {\n  padding: 0.75rem;\n}\n\n.sp-p-4 {\n  padding: 1rem;\n}\n\n.sp-p-10 {\n  padding: 2.5rem;\n}\n\n.sp-py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.sp-px-1 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n\n.sp-py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.sp-px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.sp-py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.sp-px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.sp-px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.sp-px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n.sp-px-10 {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n\n.sp-py-12 {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\n.sp-pt-1 {\n  padding-top: 0.25rem;\n}\n\n.sp-pb-1 {\n  padding-bottom: 0.25rem;\n}\n\n.sp-pt-2 {\n  padding-top: 0.5rem;\n}\n\n.sp-pr-2 {\n  padding-right: 0.5rem;\n}\n\n.sp-pb-2 {\n  padding-bottom: 0.5rem;\n}\n\n.sp-pb-4 {\n  padding-bottom: 1rem;\n}\n\n.sp-pl-4 {\n  padding-left: 1rem;\n}\n\n.sp-pb-5 {\n  padding-bottom: 1.25rem;\n}\n\n.sp-pb-6 {\n  padding-bottom: 1.5rem;\n}\n\n.sp-absolute {\n  position: absolute;\n}\n\n.sp-relative {\n  position: relative;\n}\n\n.sp-top-0 {\n  top: 0;\n}\n\n.sp-right-0 {\n  right: 0;\n}\n\n.sp-bottom-0 {\n  bottom: 0;\n}\n\n.sp-left-0 {\n  left: 0;\n}\n\n.sp-shadow-inner {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n\n.sp-fill-current {\n  fill: currentColor;\n}\n\n.sp-text-left {\n  text-align: left;\n}\n\n.sp-text-center {\n  text-align: center;\n}\n\n.sp-text-right {\n  text-align: right;\n}\n\n.sp-text-black {\n  color: #000;\n}\n\n.sp-text-white {\n  color: #fff;\n}\n\n.sp-text-xs {\n  font-size: 0.8125rem;\n}\n\n.sp-text-sm {\n  font-size: 0.875rem;\n}\n\n.sp-text-base {\n  font-size: 1rem;\n}\n\n.sp-text-lg {\n  font-size: 1.125rem;\n}\n\n.sp-italic {\n  font-style: italic;\n}\n\n.sp-no-underline {\n  text-decoration: none;\n}\n\n.sp-antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.sp-whitespace-no-wrap {\n  white-space: nowrap;\n}\n\n.sp-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sp-w-3 {\n  width: 0.75rem;\n}\n\n.sp-w-4 {\n  width: 1rem;\n}\n\n.sp-w-5 {\n  width: 1.25rem;\n}\n\n.sp-w-6 {\n  width: 1.5rem;\n}\n\n.sp-w-8 {\n  width: 2rem;\n}\n\n.sp-w-24 {\n  width: 6rem;\n}\n\n.sp-w-1\\/3 {\n  width: 33.333333%;\n}\n\n.sp-w-1\\/4 {\n  width: 25%;\n}\n\n.sp-w-2\\/4 {\n  width: 50%;\n}\n\n.sp-w-1\\/5 {\n  width: 20%;\n}\n\n.sp-w-1\\/6 {\n  width: 16.666667%;\n}\n\n.sp-w-full {\n  width: 100%;\n}\n\n.sp-z-0 {\n  z-index: 0;\n}\n\n.sp-z-40 {\n  z-index: 40;\n}\n\n.sp-z-50 {\n  z-index: 50;\n}\n\n.sp-gap-2 {\n  grid-gap: 0.5rem;\n  gap: 0.5rem;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: #fff;\n}\n\n#sp-theme-template {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n#sp-page {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 10;\n  background-color: transparent !important;\n  background-image: none !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n}\n\nhr {\n  margin: 20px 0;\n  opacity: 0.5;\n  border-color: currentColor;\n}\n\nol {\n  list-style: number;\n  list-style-position: inside;\n}\n\nul {\n  list-style: disc;\n  list-style-position: inside;\n}\n\nfieldset {\n  padding: 0;\n  margin: 0;\n}\n\nlegend {\n  font-weight: bold;\n}\n\nblockquote {\n  background: #f9f9f9;\n  border-left: 10px solid #ccc;\n  margin: 1.5em 10px;\n  padding: 0.5em 10px;\n  quotes: \"\\201C\"\"\\201D\"\"\\2018\"\"\\2019\";\n}\n\nblockquote:before {\n  color: #ccc;\n  content: open-quote;\n  font-size: 4em;\n  line-height: 0.1em;\n  margin-right: 0.25em;\n  vertical-align: -0.4em;\n}\n\nblockquote p {\n  display: inline;\n}\n\n.sp-el-section {\n  padding: 10px;\n}\n\n.sp-el-row {\n  max-width: 1000px;\n  padding: 0;\n}\n\n.sp-el-col {\n  padding: 10px;\n}\n\n.sp-el-block {\n  padding: 10px;\n}\n\n#sp-page h1,\n#sp-page h2,\n#sp-page h3,\n#sp-page h4,\n#sp-page h5,\n#sp-page h6 {\n  margin: 0;\n}\n\n.sp-form-input:focus {\n  box-shadow: none;\n}\n\n.sp-login-wrapper input[type=\"password\"] {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.sp-optin-submit:active {\n  outline: 0;\n}\n\n.sp-content-1 {\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.sp-content-2 {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.sp-content-3 {\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n\n.sp-content-4 {\n  align-items: center;\n  justify-content: center;\n}\n\n.sp-content-5 {\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.sp-content-6 {\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.sp-content-7 {\n  align-items: flex-start;\n  justify-content: flex-end;\n}\n\n.sp-content-8 {\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.sp-content-9 {\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n.sp-header-tag-h1,\nh1 {\n  font-size: 36px;\n}\n\n.sp-header-tag-h2,\nh2 {\n  font-size: 30px;\n}\n\n.sp-header-tag-h3,\nh3 {\n  font-size: 24px;\n}\n\n.sp-header-tag-h4,\nh4 {\n  font-size: 18px;\n}\n\n.sp-header-tag-h5,\nh5 {\n  font-size: 14px;\n}\n\n.sp-header-tag-h6,\nh6 {\n  font-size: 12px;\n}\n\n.sp-header-tag-h1,\nh1,\n.sp-header-tag-h2,\nh2,\n.sp-header-tag-h3,\nh3,\n.sp-header-tag-h4,\nh4,\n.sp-header-tag-h5,\nh5,\n.sp-header-tag-h6,\nh6 {\n  line-height: 1.2;\n}\n\nimg {\n  display: inline-block;\n}\n\n.fab {\n  font-weight: normal;\n}\n\n.spBgcover {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-attachment: fixed;\n  min-height: 100%;\n}\n\n.spBgcoverscroll {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-attachment: scroll;\n  min-height: 100%;\n}\n\n.spBgcontain {\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-attachment: fixed;\n  min-height: 100%;\n}\n\n.spBgcontainscroll {\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-attachment: scroll;\n  min-height: 100%;\n}\n\n@supports (-webkit-touch-callout: none) {\n  .spBgcover,\n  .spBgcontain {\n    background-attachment: scroll;\n  }\n}\n\n.spBgfull {\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-attachment: scroll;\n  min-height: 100%;\n}\n\n.spBgfullbottom {\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  background-position: center bottom;\n  background-attachment: scroll;\n  min-height: 100%;\n}\n\n.spBgrepeat {\n  background-repeat: repeat;\n  background-position: center top;\n  background-attachment: scroll;\n  min-height: 100%;\n}\n\n.spBgrepeattop {\n  background-repeat: repeat-x;\n  background-position: center top;\n  background-attachment: scroll;\n}\n\n.spBgrepeatbottom {\n  background-repeat: repeat-x;\n  background-position: center bottom;\n  background-attachment: scroll;\n  min-height: 100%;\n}\n\n.spBgrepeatvc {\n  background-repeat: repeat-y;\n  background-position: center top;\n  background-attachment: scroll;\n  min-height: 100%;\n}\n\n#sp-page .sp-form-input {\n  border-width: 0;\n}\n\n#sp-page input[type=\"text\"],\n#sp-page input[type=\"password\"],\n#sp-page input[type=\"email\"],\n#sp-page input[type=\"url\"],\n#sp-page input[type=\"date\"],\n#sp-page input[type=\"month\"],\n#sp-page input[type=\"time\"],\n#sp-page input[type=\"datetime\"],\n#sp-page input[type=\"datetime-local\"],\n#sp-page input[type=\"week\"],\n#sp-page input[type=\"number\"],\n#sp-page input[type=\"search\"],\n#sp-page input[type=\"tel\"],\n#sp-page input[type=\"color\"],\n#sp-page select,\n#sp-page textarea {\n  border: 1px #ccc solid;\n  background: #fff;\n}\n\n.sp-video-responsive {\n  overflow: hidden;\n  padding-bottom: 56.25%;\n  position: relative;\n  height: 0;\n}\n\n.sp-video-responsive iframe {\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-4-3 .wp-block-embed__wrapper:before,\n.wp-embed-responsive .wp-has-aspect-ratio .wp-block-embed__wrapper:before {\n  padding-top: 0 !important;\n}\n\n.sp-map-responsive {\n  position: relative;\n  height: 0;\n}\n\n.sp-map-responsive iframe {\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n.sp-button {\n  border-radius: 4px;\n}\n\na.sp-button:hover {\n  text-decoration: none !important;\n  transition: 0.3s;\n}\n\n.sp-ss:hover,\n.sp-sp:hover {\n  -webkit-filter: brightness(90%);\n  filter: brightness(90%);\n  transition: 0.3s;\n  text-decoration: none;\n}\n\n.sp-ss-twitter {\n  background: #000;\n  color: #fff !important;\n  text-decoration: none;\n}\n\n.sp-ss-facebook {\n  background: #1877f2;\n  color: #fff !important;\n  text-decoration: none;\n}\n\n.sp-ss-linkedin {\n  background: #0073b1;\n  color: #fff !important;\n  text-decoration: none;\n}\n\n.sp-ss-pinterest {\n  background: #e60023;\n  color: #fff !important;\n  text-decoration: none;\n}\n\n.sp-ss {\n  border-radius: 3px;\n  font-family: sans-serif;\n}\n\n.sp-ss-sm {\n  padding: 2px 5px;\n  font-size: 13px;\n}\n\n.sp-ss-md {\n  padding: 4px 10px;\n  font-size: 16px;\n}\n\n.sp-ss-lg {\n  padding: 8px 14px;\n  font-size: 20px;\n}\n\n.sp-starrating i:last-of-type {\n  padding-right: 0 !important;\n}\n\nsummary::-webkit-details-marker {\n  display: none;\n}\n\ndetails > summary:first-of-type {\n  list-style-type: none;\n}\n\ndetails {\n  display: block;\n  width: 100%;\n}\n\ndetails .sp-acc-open {\n  display: none;\n}\n\ndetails[open] .sp-acc-closed {\n  display: none;\n}\n\ndetails[open] .sp-acc-open {\n  display: block;\n}\n\nsummary {\n  outline: 0;\n  cursor: pointer;\n}\n\n.sp-accordion-wrapper hr {\n  margin: 0;\n}\n\n.woocommerce input,\n.woocommerce select,\n.woocommerce textarea {\n  border-color: #ddd;\n  border-style: solid;\n  border-width: 1px;\n  background-color: #fff;\n  padding: 8px;\n  border-radius: 3px;\n}\n\n.select2-container--default .select2-selection--single {\n  border-color: #ddd !important;\n  padding-top: 2px;\n  height: 36px !important;\n}\n\n.select2-selection__rendered {\n  border-color: transparent !important;\n}\n\n.woocommerce #place_order {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.woocommerce-additional-fields h3 {\n  margin-top: 10px;\n}\n\n.wc-proceed-to-checkout .checkout-button {\n  width: 100%;\n  text-align: center;\n}\n\n.woocommerce .onsale {\n  min-width: 50px !important;\n  min-height: 50px !important;\n  font-size: 13px;\n}\n\n#cspio-bypass {\n  border: 1px solid #ccc !important;\n}\n\n#cspio-bypass-btn {\n  color: #fff;\n}\n\n.sp-testimonials-wrapper {\n  position: relative;\n}\n\n.sp-dynamic-text {\n  visibility: hidden;\n}\n\n.sp-imagecarousels-wrapper {\n  position: relative;\n}\n\n.sp-progressbar-block-template-2 > div {\n  border-bottom: 3px solid rgba(0, 0, 0, 0.25);\n}\n\n.sp-progressbar-block-template-3 > div {\n  background-image: linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.15) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255, 255, 255, 0.15) 50%,\n    rgba(255, 255, 255, 0.15) 75%,\n    transparent 75%,\n    transparent\n  );\n  background-size: 16px 16px;\n}\n\n.sp-progressbar-block-template-4 > div {\n  background-image: linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.15) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255, 255, 255, 0.15) 50%,\n    rgba(255, 255, 255, 0.15) 75%,\n    transparent 75%,\n    transparent\n  );\n  background-size: 16px 16px;\n  -webkit-animation: progress-bar-stripes 1s linear infinite;\n  animation: progress-bar-stripes 1s linear infinite;\n}\n\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 0 16px;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 0 16px;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n.sp-testimonial-img {\n  width: 60px;\n  height: 60px;\n}\n\n.sp-testimonial-nav button:first-child,\n.sp-testimonial-nav button:last-child {\n  background: transparent;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-twitter {\n  color: #000 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-facebook,\n.sp-socialprofiles-style-1 .sp-sp-facebook-messenger {\n  color: #1877f2 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-slack {\n  color: #4a154b !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-vimeo {\n  color: #2fb1e3 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-weibo {\n  color: #ce282b !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-whatsapp {\n  color: #38af48 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-tiktok {\n  color: #fe2c55 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-x-twitter {\n  color: #fe2c55 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-imdb {\n  color: #f5c517 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-linkedin {\n  color: #0073b1 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-pinterest {\n  color: #e60023 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-youtube {\n  color: #f00 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-instagram {\n  color: #f77737 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-snapchat {\n  color: #fffc00 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-wordpress {\n  color: #0073aa !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-github {\n  color: #000 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-soundcloud {\n  color: #fe5000 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-rss {\n  color: #ee802f !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-envelope {\n  color: #db4437 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-phone {\n  color: #2c9ada !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-medium-m {\n  color: #21de68 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-discord {\n  color: #5567e3 !important;\n}\n\n.sp-socialprofiles-style-1 .sp-sp-telegram-plane {\n  color: #299ccd !important;\n}\n\n.sp-sp {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sp-sp-twitter {\n  background: #000;\n  text-decoration: none;\n}\n\n.sp-sp-facebook,\n.sp-sp-facebook-messenger {\n  background: #1877f2;\n  text-decoration: none;\n}\n\n.sp-sp-slack {\n  background: #4a154b;\n  text-decoration: none;\n}\n\n.sp-sp-vimeo {\n  background: #2fb1e3;\n  text-decoration: none;\n}\n\n.sp-sp-weibo {\n  background: #ce282b;\n  text-decoration: none;\n}\n\n.sp-sp-whatsapp {\n  background: #38af48;\n  text-decoration: none;\n}\n\n.sp-sp-tiktok {\n  background: #fe2c55;\n  text-decoration: none;\n}\n\n.sp-sp-linkedin {\n  background: #0073b1;\n  text-decoration: none;\n}\n\n.sp-sp-pinterest {\n  background: #e60023;\n  text-decoration: none;\n}\n\n.sp-sp-youtube {\n  background: red;\n  text-decoration: none;\n}\n\n.sp-sp-instagram {\n  background: #f77737;\n  text-decoration: none;\n}\n\n.sp-sp-snapchat {\n  background: #fffc00;\n  text-decoration: none;\n}\n\n.sp-sp-wordpress {\n  background: #0073aa;\n  text-decoration: none;\n}\n\n.sp-sp-github {\n  background: #000;\n  text-decoration: none;\n}\n\n.sp-sp-soundcloud {\n  background: #fe5000;\n  text-decoration: none;\n}\n\n.sp-sp-rss {\n  background: #ee802f;\n  text-decoration: none;\n}\n\n.sp-sp-envelope {\n  background: #db4437;\n  text-decoration: none;\n}\n\n.sp-sp-phone {\n  background: #2c9ada;\n  text-decoration: none;\n}\n\n.sp-sp-medium-m {\n  background: #21de68;\n  text-decoration: none;\n}\n\n.sp-sp-discord {\n  background: #5567e3;\n  text-decoration: none;\n}\n\n.sp-sp-telegram-plane {\n  background: #299ccd;\n  text-decoration: none;\n}\n\n.sp-countdown-group {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sp-cd-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.sp-cd-amount {\n  padding: 20px;\n  line-height: 1;\n}\n\n.sp-countdown-sm .sp-cd-amount {\n  font-size: 20px;\n  padding: 10px;\n}\n\n.sp-countdown-md .sp-cd-amount {\n  font-size: 30px;\n  padding: 15px;\n}\n\n.sp-countdown-lg .sp-cd-amount {\n  font-size: 40px;\n  padding: 20px;\n}\n\n.sp-bulletlist-block-template-0 .sp-icon-wrapper i {\n  width: auto !important;\n  line-height: 1 !important;\n}\n\n.sp-bulletlist-block-template-1 .sp-icon-wrapper i {\n  text-align: center;\n  background: #fff;\n  border-radius: 999px;\n}\n\n.sp-bulletlist-block-template-2 .sp-icon-wrapper i {\n  text-align: center;\n  background: #fff;\n  border-radius: 6px;\n}\n\n.sp-bulletlist-block-template-3 .sp-icon-wrapper i {\n  text-align: center;\n  background: #fff;\n  border-radius: 0;\n}\n\n.sp-bulletlist-block-template-4 .sp-icon-wrapper i {\n  text-align: center;\n  background: #444;\n  border-radius: 999px;\n}\n\n.sp-bulletlist-block-template-5 .sp-icon-wrapper i {\n  text-align: center;\n  background: #444;\n  border-radius: 6px;\n}\n\n.sp-bulletlist-block-template-6 .sp-icon-wrapper i {\n  text-align: center;\n  background: #444;\n  border-radius: 0;\n}\n\n.sp-input-size-2 {\n  height: 33px;\n}\n\n.sp-input-size-3 {\n  height: 42px;\n}\n\n.sp-input-size-4 {\n  height: 56px;\n}\n\n@-webkit-keyframes sp-ajax-stripes {\n  from {\n    background-position: 48px 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n@keyframes sp-ajax-stripes {\n  from {\n    background-position: 48px 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n.sp-ajax-animated {\n  -webkit-animation: sp-ajax-stripes 1s linear infinite;\n  animation: sp-ajax-stripes 1s linear infinite;\n}\n\n.sp-ajax-striped {\n  background-image: linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.15) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255, 255, 255, 0.15) 50%,\n    rgba(255, 255, 255, 0.15) 75%,\n    transparent 75%,\n    transparent\n  ) !important;\n  background-size: 1rem 1rem !important;\n}\n\n#tubular-container iframe {\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n\n#tubular-container .active {\n  opacity: 1;\n}\n\n.sp-spacer {\n    height: 37px;\n  }\n\n@media (max-width: 640px) {\n  .sp-spacer {\n    height: 1vh !important;\n  }\n\n  .sp-countdown-group {\n    flex-wrap: wrap;\n  }\n\n  .sp-cd-group {\n    margin-bottom: 1vh !important;\n  }\n\n  .sp-socialsharing-wrapper,\n  .sp-nav,\n  .sp-button-wrapper,\n  .sp-image-wrapper {\n    text-align: center !important;\n    justify-content: center !important;\n  }\n\n  .sp-pricing-table-wrapper {\n    border: 1px #ffffff1f solid;\n    text-align: center !important;\n    justify-content: center !important;\n  }\n\n  @media (max-width: 768px) {\n    .sp-el-section,\n    .sp-el-row,\n    .sp-el-col,\n    .sp-el-block,\n    .sp-optin-wrapper,\n    .sp-testimonials-wrapper,\n    .sp-testimonial-wrapper {\n      padding-top: 4px !important;\n    }\n  }\n\n  .sp-el-block {\n    padding: 0px;\n    padding-bottom: 20px;\n  }\n\n  .sp-w-full {\n    width: 100% !important;\n  }\n\n  .sp-optinform-field,\n  .sp-optinform-btn {\n    display: block !important;\n    width: 100% !important;\n  }\n\n  /*img:not(\".sp-testimonial-img\") {*/\n  /*  height: auto !important*/\n  /*}*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    text-align: center !important;\n  }\n\n  .sp-socialprofiles-wrapper {\n    text-align: center !important;\n    justify-content: center !important;\n  }\n\n  .sp-feature-wrapper {\n    text-align: center !important;\n  }\n\n  .sp-feature-wrapper img,\n  .sp-feature-wrapper i {\n    margin: 0 !important;\n    margin-bottom: 16px !important;\n  }\n\n  .sp-wccustomproductsgrid-wrapper li.product {\n    float: none !important;\n    width: 100% !important;\n  }\n}\n\n#cspio-bypass-btn {\n  font-size: 15px;\n  height: 27px;\n  padding: 0 14px;\n  border-radius: 4px;\n}\n\ninput[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  border-width: 1px;\n  border-radius: 0.25rem;\n  padding-top: 0.25rem;\n  padding-right: 0.5rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  line-height: 1.5;\n}\n\n.sp-credit {\n  background-color: rgba(0, 0, 0, 0.8);\n  position: fixed;\n  bottom: 0;\n  right: 20px;\n  font-size: 10px;\n  padding: 7px;\n  border-radius: 2px;\n  line-height: 1;\n  color: #fff;\n  z-index: 10;\n  font-family: sans-serif;\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.sp-credit img {\n  width: 64px;\n}\n\n.sp-credit span {\n  padding-top: 3px;\n  padding-right: 2px;\n  color: #fff;\n}\n\n.sp-credit a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sp-plan-price {\n  text-align: center;\n}\n\n.sp-plan-price-sup {\n  top: -2.5em;\n}\n\n.sp-plan-price-sub {\n  left: -7%;\n  bottom: 0;\n}\n\n.sp-notifications-custom {\n  background: #fdf6f4;\n  border: 1px solid #f6d2c7;\n}\n\n.sp-notification-button {\n  background: #0f8a5e !important;\n  border: #0f8a5e !important;\n  color: #fff !important;\n  text-decoration: none !important;\n  text-shadow: none !important;\n}\n\n.pabloo-menu {\n  box-sizing: border-box;\n}\n\n.pabloo-menu-fixed {\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 3;\n}\n\n.pabloo-menu-list,\n.menu-item {\n  position: relative;\n}\n\n.pabloo-menu-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.menu-item {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n\n.pabloo-menu-link,\n.pabloo-menu-heading {\n  display: block;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.pabloo-menu-horizontal .nav-menu {\n  width: 100%;\n  white-space: nowrap;\n}\n\n.pabloo-menu-horizontal .nav-menu .pabloo-menu-list {\n  display: inline-block;\n}\n\n.pabloo-menu-horizontal .nav-menu .menu-item,\n.pabloo-menu-horizontal .nav-menu .pabloo-menu-heading,\n.pabloo-menu-horizontal .nav-menu .pabloo-menu-separator {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.menu-item .menu-item {\n  display: block;\n  white-space: nowrap;\n}\n\n.pabloo-menu-horizontal .menu-item .menu-item {\n  display: block;\n}\n\n.sub-menu {\n  display: none;\n  position: absolute;\n  left: 100%;\n  top: 0;\n  margin: 0;\n  padding: 0;\n  z-index: 3;\n}\n\n.pabloo-menu-horizontal .nav-menu .sub-menu {\n  left: 0;\n  top: auto;\n  width: inherit;\n}\n\n.pabloo-menu-horizontal .nav-menu .sub-menu .sub-menu {\n  left: 100%;\n  top: 0;\n  width: inherit;\n}\n\n.menu-item-has-children:hover > .sub-menu,\n.pabloo-menu-active > .sub-menu {\n  display: block;\n  position: absolute;\n}\n\n.menu-item-has-children > a:after {\n  padding-left: 0.5em;\n  content: \"\\25B8\";\n  font-size: inherit;\n}\n\n.menu-item-has-children .sub-menu-toggle {\n  display: none;\n}\n\n.pabloo-menu-horizontal .nav-menu .menu-item-has-children > a:after {\n  content: \"\\25BE\";\n}\n\n.pabloo-menu-scrollable {\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.pabloo-menu-scrollable .pabloo-menu-list {\n  display: block;\n}\n\n.h .pabloo-menu-horizontal.pabloo-menu-scrollable .pabloo-menu-list {\n  display: inline-block;\n}\n\n.h .pabloo-menu-horizontal.pabloo-menu-scrollable {\n  white-space: nowrap;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  padding: 0.5em 0;\n}\n\n.pabloo-menu-separator,\n.h .pabloo-menu-horizontal .sub-menu .pabloo-menu-separator {\n  background-color: #ccc;\n  height: 1px;\n  margin: 0.3em 0;\n}\n\n.h .pabloo-menu-horizontal .pabloo-menu-separator {\n  width: 1px;\n  height: 1.3em;\n  margin: 0 0.3em;\n}\n\n.h .pabloo-menu-horizontal .sub-menu .pure-menu-separator {\n  display: block;\n  width: auto;\n}\n\n.pabloo-menu-heading {\n  text-transform: uppercase;\n  color: #565d64;\n}\n\n.pabloo-menu-link {\n  color: #777;\n}\n\n.sub-menu {\n  background-color: #fff;\n}\n\n.pabloo-menu-link,\n.pabloo-menu-heading {\n  padding: 0.5em 1em;\n}\n\n.pabloo-menu-disabled {\n  opacity: 0.5;\n}\n\n.pabloo-menu-disabled .pabloo-menu-link:hover {\n  background-color: transparent;\n  cursor: default;\n}\n\n.pabloo-menu-active > .pabloo-menu-link,\n.pabloo-menu-link:hover,\n.pabloo-menu-link:focus {\n  background-color: #eee;\n}\n\n.pabloo-menu-selected > .pabloo-menu-link,\n.pabloo-menu-selected > .pabloo-menu-link:visited {\n  color: #000;\n}\n\n.nav-bar {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem 1.5rem;\n}\n\n.hamburger {\n  display: none;\n}\n\n.bar {\n  display: block;\n  width: 25px;\n  height: 3px;\n  margin: 5px auto;\n  transition: all 0.3s ease-in-out;\n  background-color: #101010;\n}\n\n.sp-nested-nav-wrapper .nav-bar {\n  padding: 0;\n}\n\n@media only screen and (max-width: 786px) {\n  .custom-restricted-width {\n    width: 99%;\n    display: block;\n  }\n\n  .sp-nested-nav-wrapper {\n    width: 100%;\n  }\n\n  .sp-mobile-menu-true ul.pabloo-menu-list {\n    display: inline-block;\n    width: 100%;\n    text-align: left;\n  }\n\n  .sp-mobile-menu-true .nav-bar {\n    padding: 0;\n  }\n\n  .sp-mobile-menu-true .menu-item-has-children:hover > .sub-menu {\n    width: 100%;\n    display: none;\n  }\n\n  .sp-mobile-menu-true\n    .menu-item-has-children.pabloo-menu-active\n    > .sub-menu {\n    width: 100%;\n    display: block !important;\n    left: 0;\n    position: relative;\n  }\n\n  .pabloo-menu-horizontal.sp-mobile-menu-true .nav-menu .sub-menu .sub-menu {\n    left: 0;\n    top: auto;\n    width: inherit;\n  }\n\n  .pabloo-menu-horizontal.sp-mobile-menu-true .menu-item,\n  .pabloo-menu-horizontal.sp-mobile-menu-true .pure-menu-heading,\n  .pabloo-menu-horizontal.sp-mobile-menu-true .pure-menu-separator {\n    display: block !important;\n    padding: 0 !important;\n  }\n\n  .custom-restricted-width.sp-mobile-menu-true .menu-item,\n  .custom-restricted-width.sp-mobile-menu-true .pure-menu-heading,\n  .custom-restricted-width.sp-mobile-menu-true .pure-menu-separator {\n    display: block !important;\n    padding: 0 !important;\n  }\n\n  .sp-mobile-menu-true .menu-item a {\n    display: block;\n    width: 100%;\n  }\n\n  .sp-mobile-menu-true .nav-menu .menu-item {\n    display: block !important;\n    font-size: 22px;\n    line-height: 26px;\n  }\n\n  .sp-mobile-menu-true .nav-menu {\n    display: none;\n  }\n\n  .sp-mobile-menu-true .nav-menu.active {\n    display: block;\n    background-color: transparent;\n    width: 100%;\n    padding: 10px;\n    text-align: center;\n  }\n\n  .sp-mobile-menu-true .nav-menu.active {\n    left: 0;\n  }\n\n  .sp-mobile-menu-true .hamburger {\n    display: block;\n    cursor: pointer;\n  }\n\n  .sp-mobile-menu-true .hamburger.active .bar:nth-child(2) {\n    opacity: 0;\n  }\n\n  .sp-mobile-menu-true .hamburger.active .bar:nth-child(1) {\n    -webkit-transform: translateY(8px) rotate(45deg);\n    transform: translateY(8px) rotate(45deg);\n  }\n\n  .sp-mobile-menu-true .hamburger.active .bar:nth-child(3) {\n    -webkit-transform: translateY(-8px) rotate(-45deg);\n    transform: translateY(-8px) rotate(-45deg);\n  }\n\n  .sp-mobile-menu-false .nav-menu .pabloo-menu-list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .sp-nav-wrapper,\n  .sp-nav-wrapper li {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 !important;\n    padding: 5px 0 !important;\n  }\n}\n\n.sub-menu .menu-item {\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n}\n\n@media (max-width: 786px) {\n  .menu-item {\n    margin-top: 2px !important;\n    margin-bottom: 2px !important;\n  }\n\n  .menu-item a {\n    text-align: left !important;\n  }\n}\n\n.sp-mobile-menu-true ul.sub-menu {\n  padding-left: 10px;\n}\n\n.custom-restricted-width .menu-item:first-child {\n  padding-top: 0 !important;\n}\n\n.custom-restricted-width .menu-item:last-child {\n  padding-bottom: 0 !important;\n}\n\n.sub-menu li {\n  text-align: left !important;\n}\n\n.custom-restricted-width .sub-menu .menu-item {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n\n.pabloo-menu-list > ul {\n  display: flex;\n  list-style: none;\n}\n\n.pabloo-menu-list > ul li {\n  padding: 0 20px;\n}\n\n.pabloo-menu-list > ul li:nth-of-type(1n + 4) {\n  display: none;\n}\n\n.woocommerce .products ul,\n.woocommerce ul.products {\n  margin-bottom: 0 !important;\n}\n\n.sp-custom-grid {\n  display: grid;\n}\n\n.sp-custom-gap-4 {\n  grid-gap: 1rem;\n  gap: 1rem;\n}\n\n.sp-custom-grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-8 {\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-9 {\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-10 {\n  grid-template-columns: repeat(10, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-11 {\n  grid-template-columns: repeat(11, minmax(0, 1fr));\n}\n\n.sp-custom-grid-cols-12 {\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n\n.sp-custom-col-span-1 {\n  grid-column: span 1 / span 1;\n}\n\n.sp-custom-col-span-2 {\n  grid-column: span 2 / span 2;\n}\n\n.sp-custom-col-span-3 {\n  grid-column: span 3 / span 3;\n}\n\n.sp-custom-col-span-4 {\n  grid-column: span 4 / span 4;\n}\n\n.sp-custom-col-span-5 {\n  grid-column: span 5 / span 5;\n}\n\n.sp-custom-col-span-6 {\n  grid-column: span 6 / span 6;\n}\n\n.sp-custom-col-span-7 {\n  grid-column: span 7 / span 7;\n}\n\n.sp-custom-col-span-8 {\n  grid-column: span 8 / span 8;\n}\n\n.sp-custom-col-span-9 {\n  grid-column: span 9 / span 9;\n}\n\n.sp-custom-col-span-10 {\n  grid-column: span 10 / span 10;\n}\n\n.sp-custom-col-span-11 {\n  grid-column: span 11 / span 11;\n}\n\n.sp-custom-col-span-12 {\n  grid-column: span 12 / span 12;\n}\n\n.sp-custom-col-span-full {\n  grid-column: 1 / -1;\n}\n\n.woocommerce .products ul,\n.woocommerce ul.products {\n  margin-bottom: 0 !important;\n}\n\n.woocommerce .button.wp-element-button {\n  padding: 10px;\n}\n\n.gallery {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.gallery-item {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.sp-searchform button {\n  background: #ccc;\n}\n\n.sp-searchform input {\n  color: #444;\n}\n\n@media only screen and (max-width: 480px) {\n  .sp-custom-grid-cols-2 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-3 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-4 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-5 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-6 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-7 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-8 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-9 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-10 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-11 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n\n  .sp-custom-grid-cols-12 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n  }\n}\n\n.sp-postauthorbox-avatar img {\n  border-radius: 9999px;\n}\n\n.sp-flex-none.sp-postauthorbox-avatar {\n  flex: none;\n}\n\n.sp-p-2.sp-postauthorbox-avatar {\n  padding: 0.5rem;\n}\n\n.sp-postcomments-wrapper .comments-area .comments-title,\n#reply-title {\n  font-size: 24px;\n}\n\n.sp-postcomments-wrapper .comments-area .avatar {\n  border-radius: 9999px;\n  float: left;\n  margin: 0 10px 0 0;\n  width: 48px;\n  height: 48px;\n  margin-left: -27px;\n}\n\n.sp-postcomments-wrapper .comments-area .says {\n  display: none;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-author {\n  margin-top: -90px;\n}\n\n.sp-postcomments-wrapper .comments-area .fn {\n  font-style: normal;\n  margin: 5px 0 0 0;\n  font-size: 18px;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-metadata {\n  font-size: 12px;\n  margin-bottom: 45px;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-body {\n  border: 1px solid #ebebeb;\n  padding: 30px 30px 10px 30px;\n  margin-top: 75px;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.pingback .comment-body,\n.pingback .comment-author {\n  margin-top: 0 !important;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-body p {\n  line-height: 1.625;\n  margin-bottom: 25px;\n}\n\n.sp-postcomments-wrapper .comments-area .reply a {\n  padding: 5px 10px;\n  color: #444;\n  text-decoration: none;\n  background: #e9eaeb;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  font-size: 12px;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-form .logged-in-as {\n  font-size: 12px;\n}\n\n.sp-postcomments-wrapper #comments ol {\n  list-style: none;\n}\n\n.sp-postcomments-wrapper .comment-list {\n  padding-left: 0;\n}\n\n.sp-postcomments-wrapper #comments .edit-link {\n  text-decoration: none;\n}\n\n.sp-postcomments-wrapper .sp-postcomments-no-display {\n  display: none;\n}\n\n.comment-form-cookies-consent {\n  display: flex;\n  align-items: center;\n}\n\n#wp-comment-cookies-consent {\n  margin-right: 8px;\n}\n\n.comment-form-author,\n.comment-form-email,\n.comment-form-cookies-consent {\n  margin-bottom: 10px;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-form label {\n  display: block;\n  font-size: 13px;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-form textarea {\n  height: 130px;\n  max-width: 100%;\n}\n\n/*.sp-postcomments-wrapper .comments-area .comment-form input:not:[type=\"submit\"],*/\n.sp-postcomments-wrapper .comments-area .comment-form textarea {\n  font-size: 16px;\n  padding: 12px 15px;\n  width: 100%;\n  border-radius: 3px;\n  margin-bottom: 16px;\n}\n\n.sp-postcomments-wrapper .comments-area .comment-form .form-submit .submit {\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: center;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  white-space: nowrap;\n  padding: 6px 12px;\n  font-size: 15px;\n  line-height: 1.8;\n  border-radius: 4px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transition: all 0.2s ease;\n  display: inline-block;\n  width: auto;\n  height: auto;\n}\n\n.sp-postcomments-wrapper .comment-form .commentpolicy {\n  font-size: 13px;\n  margin-bottom: 10px;\n}\n\n#reply-title {\n  margin-bottom: 20px;\n}\n\n@media only screen and (min-width: 480px) {\n  .sp-postnavigation-wrapper .sp-postnavigation-previous-next {\n    display: flex;\n    justify-content: space-between;\n  }\n}\n\n.sp-postnavigation-wrapper .sp-postnavigation-previous {\n  overflow: hidden;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n}\n\n.sp-postnavigation-wrapper .sp-postnavigation-next {\n  overflow: hidden;\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n}\n\n.sp-postnavigation-wrapper .sp-postnavigation-previous-label,\n.sp-postnavigation-wrapper .sp-postnavigation-next-label {\n  overflow: hidden;\n  font-size: 16px;\n  text-overflow: ellipsis;\n}\n\n.sp-postnavigation-wrapper .sp-postnavigation-previous-title,\n.sp-postnavigation-wrapper .sp-postnavigation-next-title {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  margin: 5px 30px 0;\n}\n\n.sp-postnavigation-wrapper .sp-postnavigation-previous-icon,\n.sp-postnavigation-wrapper .sp-postnavigation-next-icon {\n  vertical-align: middle;\n  display: initial;\n}\n\n.sp-postinfo-wrapper .sp-postinfo-list-items {\n  display: flex;\n  flex-wrap: wrap;\n  list-style-type: none;\n}\n\n.sp-postinfo-wrapper .sp-postinfo-item {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n.sp-postinfo-wrapper .sp-postinfo-item-icon,\n.sp-postinfo-wrapper .sp-postinfo-author-avatar {\n  padding-right: 8px;\n}\n\n.sp-postinfo-wrapper .sp-postinfo-item .sp-postinfo-author-avatar .avatar {\n  border-radius: 9999px;\n  width: 24px;\n  height: 24px;\n}\n\n.sp-postinfo-wrapper .sp-postinfo-term-name a {\n  color: inherit !important;\n}\n\n.sp-postnavigation-shortcodes a,\n.sp-postnavigation-shortcodes a:hover {\n  text-decoration: none;\n}\n\n.sp-text-block-style p:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.sp-text-block-style ul {\n  display: block;\n  list-style-type: disc;\n  list-style-position: outside;\n  margin: 0;\n  padding: 0;\n  margin-left: 2rem;\n  margin-bottom: 20px;\n}\n\n.sp-text-block-style ol {\n  display: block;\n  list-style-position: outside;\n  margin: 0;\n  padding: 0;\n  margin-left: 2rem;\n  margin-bottom: 20px;\n}\n\n.sp-text-block-style li {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.sp-postcontent p:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.sp-postcontent dl {\n  margin: 0;\n  padding: 0;\n  margin-left: 1rem;\n  margin-bottom: 20px;\n}\n\n.sp-postcontent ul {\n  display: block;\n  list-style-type: disc;\n  list-style-position: outside;\n  margin: 0;\n  padding: 0;\n  margin-left: 2rem;\n  margin-bottom: 20px;\n}\n\n.sp-postcontent ol {\n  display: block;\n  list-style-position: outside;\n  margin: 0;\n  padding: 0;\n  margin-left: 2rem;\n  margin-bottom: 20px;\n}\n\n.sp-postcontent li {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.sp-postcontent img,\n.sp-postcontent iframe {\n  margin-bottom: 20px;\n}\n\n.sp-postcontent h1,\n.sp-postcontent h2,\n.sp-postcontent h3,\n.sp-postcontent h4,\n.sp-postcontent h5,\n.sp-postcontent h6 {\n  margin-bottom: 10px;\n}\n\n.sp-postcontent table {\n  background-color: #f8f8f8;\n}\n\n.sp-postcontent table td,\n.sp-postcontent table th {\n  padding: 10px;\n}\n\n.sp-postcontent {\n  clear: both;\n}\n\n.sp-postcontent .alignright {\n  float: right;\n  padding: 0 0 0 15px;\n}\n\n.sp-postcontent .alignleft {\n  float: left;\n  padding: 0 15px 0 0;\n}\n\n.sp-postcontent .aligncenter {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n\n.sp-menu-cart-wrapper .sp-menu-cart-item-count {\n  top: -0.4em;\n  right: -0.9em;\n  position: absolute;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  padding-top: 0.25em;\n  padding-bottom: 0.25em;\n  line-height: 1;\n  font-weight: 600;\n  justify-content: center;\n  align-items: center;\n  display: inline-flex;\n  border-radius: 9999px;\n}\n\n.sp-posts-single-block a,\n.sp-posts-single-block a:hover {\n  text-decoration: none;\n}\n\n.sp-posts-single-block {\n  overflow: hidden;\n}\n\n.page-numbers {\n  margin-right: 4px;\n}\n\n.blog .sp-type-archivetitle {\n  display: none;\n}\n\n.widget {\n  margin-bottom: 0;\n}\n\n.sp-el-section,\n.sp-el-col,\n.sp-el-row {\n  position: relative;\n}\n\n.sp-section-shape,\n.sp-row-shape,\n.sp-col-shape {\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  line-height: 0;\n  direction: ltr;\n}\n\n.sp-section-top,\n.sp-row-top,\n.sp-col-top {\n  top: 0;\n}\n\n.sp-section-bottom,\n.sp-row-bottom,\n.sp-col-bottom {\n  bottom: 0;\n}\n\n.sp-section-shape svg,\n.sp-row-shape svg,\n.sp-col-shape svg {\n  display: block;\n  width: 100%;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  position: relative;\n}\n\n.sp-section-bottom,\n.sp-row-bottom,\n.sp-col-bottom {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.sp-section-shape .pabloo-shape-fill,\n.sp-row-shape .pabloo-shape-fill,\n.sp-col-shape .pabloo-shape-fill {\n  fill: #fff;\n}\n\n.sp-add-to-cart-wrapper form.cart {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n\n.sp-add-to-cart-wrapper form .qty {\n  padding: 10px !important;\n}\n\n.sp-add-to-cart-wrapper form.variations_form div.single_variation_wrap {\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: column;\n}\n\n.sp-add-to-cart-wrapper\n  form.variations_form\n  .single_variation_wrap\n  .single_variation,\n.sp-add-to-cart-wrapper\n  form.variations_form\n  .single_variation_wrap\n  .single_variation\n  .woocommerce-variation-description,\n.sp-add-to-cart-wrapper\n  form.variations_form\n  .single_variation_wrap\n  .single_variation\n  .woocommerce-variation-price {\n  margin: 10px 0;\n}\n\n.sp-add-to-cart-wrapper\n  form.variations_form\n  div.single_variation_wrap\n  .quantity {\n  float: left;\n  margin-right: 0.5rem;\n}\n\n.sp-add-to-cart-wrapper form.variations_form table td {\n  border: 1px solid;\n  padding: 10px;\n}\n\n.sp-add-to-cart-wrapper form.variations_form table {\n  border-collapse: collapse;\n  background-color: inherit;\n  margin: 10px 0;\n  min-width: 240px;\n  width: 100%;\n}\n\n.sp-not-found {\n  text-align: center;\n  margin: 80px 20px;\n  font-size: 32px;\n}\n\n.sp-mobile-view .sp-nav-wrapper li .sp-navmenu-list-items-divider {\n  display: none;\n}\n\n.sp-tablet-view .sp-nav-wrapper li .sp-navmenu-list-items-divider {\n  display: none;\n}\n\n.sp-tabbedlayout-horizontal {\n  display: flex;\n  flex-direction: column;\n}\n\n.sp-tabbedlayout-horizontal ul li a {\n  border-width: 1px;\n  border-color: rgb(222 226 230 / 60%);\n  border-bottom-style: none;\n  cursor: pointer;\n  padding: 3px 16px;\n  border-bottom: 0;\n}\n\n.sp-tabbedlayout-horizontal ul li a.sp-active-tab {\n  border-width: 1px;\n  border-color: #dee2e6;\n  border-bottom-style: none;\n  background: #dee2e6;\n}\n\n.sp-tabbedlayout-horizontal .tab-content-area {\n  border: 1px solid rgb(222 226 230 / 60%);\n  padding: 5px 10px;\n}\n\n.sp-tabbedlayout-vertical {\n  display: flex;\n  flex-direction: row;\n}\n\n.sp-tabbedlayout-vertical ul li a {\n  border-width: 1px;\n  border-color: rgb(222 226 230 / 60%);\n  cursor: pointer;\n  padding: 3px 16px;\n  border-right: 0;\n}\n\n.sp-tabbedlayout-vertical ul li a.sp-active-tab {\n  border-width: 1px;\n  border-color: #dee2e6;\n  background: #eee;\n}\n\n.sp-tabbedlayout-vertical .tab-content-area {\n  border: 1px solid rgb(222 226 230 / 60%);\n  padding: 5px 10px;\n  flex-grow: 1;\n}\n\n.sp-additional-information-wrapper\n  .woocommerce-product-attributes.shop_attributes {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: unset;\n}\n\n.sp-additional-information-wrapper\n  .woocommerce-product-attributes.shop_attributes\n  th,\n.sp-additional-information-wrapper\n  .woocommerce-product-attributes.shop_attributes\n  td {\n  border: 1px solid #000;\n  padding: 10px;\n}\n\n.woocommerce a.button {\n  font-size: 100%;\n  margin: 0;\n  line-height: 1;\n  cursor: pointer;\n  position: relative;\n  text-decoration: none;\n  overflow: visible;\n  padding: 0.618em 1em;\n  font-weight: 700;\n  border-radius: 3px;\n  left: auto;\n  color: #515151;\n  background-color: #ebe9eb;\n  border: 0;\n  display: inline-block;\n  background-image: none;\n  box-shadow: none;\n  text-shadow: none;\n}\n\n.sp-upsells-wrapper .up-sells ul.products,\n.sp-product-related-wrapper .related ul.products {\n  list-style: none;\n}\n\n.sp-upsells-wrapper .up-sells .onsale,\n.sp-product-related-wrapper .related .onsale {\n  min-width: 50px !important;\n  min-height: 50px !important;\n  font-size: 13px;\n}\n\n.sp-product-rating-wrapper .woocommerce.woocommerce-product-rating {\n  margin: 0;\n  align-items: center;\n  display: flex;\n}\n\n.sp-product-data-tabs-wrapper .woocommerce-tabs ul.tabs li {\n  display: inline-flex !important;\n  /*display: -webkit-inline-box !important;*/\n  margin: 0;\n}\n\n.sp-product-data-tabs-wrapper .woocommerce-tabs ul.tabs li a {\n  padding: 10px 10px;\n}\n\n.sp-product-data-tabs-wrapper .woocommerce-tabs ul li.active a {\n  box-shadow: none;\n}\n\n.sp-product-data-tabs-wrapper .woocommerce-tabs #tab-reviews #submit {\n  float: none;\n}\n\n.wc-tabs li {\n  background: #f8f8f8;\n  padding: 6px;\n}\n\n.wc-tabs li.active {\n  background: #f7f6f7;\n}\n\n.wc-tabs {\n  margin-bottom: 10px;\n}\n\n.woocommerce-order-details h2,\n.woocommerce-customer-details h2 {\n  margin-bottom: 10px;\n}\n\n.nav-menu-bar li.separator:last-child {\n  display: none;\n}\n\n.sp-divider-wrapper .sp-divider.sp-divider-with-icon {\n  display: flex;\n}\n\n.sp-divider-wrapper .sp-divider .sp-divider-separator {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  width: 100%;\n}\n\n.sp-divider-wrapper .sp-divider .sp-divider-separator::after,\n.sp-divider-wrapper .sp-divider .sp-divider-separator::before {\n  flex-grow: 1;\n  -webkit-box-flex: 1;\n}\n\n.sp-divider-wrapper .sp-divider .sp-divider-text-block {\n  padding: 0 10px;\n}\n\n.sp-divider-wrapper .sp-divider .sp-divider-text-block .sp-divider-text {\n  font-size: 15px;\n}\n\n.sp_animated_start {\n  opacity: 0;\n}\n\n.sp-counter-wrapper {\n  flex-direction: column;\n}\n\n.sp-counter-wrapper .sp-counter-title,\n.sp-counter-wrapper .sp-counter-text-wrapper {\n  display: flex;\n}\n\n.sp-counter-wrapper .sp-counter-text-wrapper .sp-counter-number-prefix,\n.sp-counter-wrapper .sp-counter-text-wrapper .sp-counter-number-suffix {\n  white-space: pre-wrap;\n}\n\n.sp-hotspot-wrapper {\n  position: relative;\n}\n\n.hotspot-wrapper {\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n}\n\n.hotspot-repeater-item {\n  left: 50%;\n  --hotspot-translate-x: 50%;\n  top: 50%;\n  --hotspot-translate-y: 50%;\n}\n\n.hotspot-item-inner-circle {\n  border-radius: 50%;\n  top: 50%;\n  left: 50%;\n  padding: 10px;\n}\n\n.hotspot-soft-beat {\n  -webkit-animation-duration: 0.7s;\n  animation-duration: 0.7s;\n  -webkit-animation-timing-function: ease;\n  animation-timing-function: ease;\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-direction: alternate;\n  animation-direction: alternate;\n  -webkit-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  animation-play-state: running;\n  -webkit-animation-name: hotspot-soft-beat;\n  animation-name: hotspot-soft-beat;\n}\n\n.hotspot-expand {\n  -webkit-animation-duration: 1.5s;\n  animation-duration: 1.5s;\n  -webkit-animation-timing-function: ease;\n  animation-timing-function: ease;\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  animation-play-state: running;\n  -webkit-animation-name: hotspot-expand;\n  animation-name: hotspot-expand;\n}\n\n@-webkit-keyframes hotspot-soft-beat {\n  from {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  to {\n    -webkit-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n}\n\n@keyframes hotspot-soft-beat {\n  from {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  to {\n    -webkit-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n}\n\n@-webkit-keyframes hotspot-expand {\n  from {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0.7;\n  }\n}\n\n@keyframes hotspot-expand {\n  from {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0.7;\n  }\n}\n\n.sp-content-toggle-area input[type=\"checkbox\"] {\n  position: relative;\n  width: 80px;\n  height: 40px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: silver;\n  outline: 0;\n  border-radius: 2rem;\n  cursor: pointer;\n  box-shadow: inset 0 0 5px rgb(0 0 0 / 50%);\n}\n\n.sp-content-toggle-area input[type=\"checkbox\"]::before {\n  content: \"\";\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #fff;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: 0.5s;\n}\n\n.sp-content-toggle-area.sp-square input[type=\"checkbox\"] {\n  border-radius: 0;\n}\n\n.sp-content-toggle-area.sp-square input[type=\"checkbox\"]::before {\n  border-radius: 0;\n}\n\n.sp-content-toggle-area.sp-label input[type=\"checkbox\"] {\n  border-radius: 0;\n}\n\n.sp-content-toggle-area.sp-label input[type=\"checkbox\"]:checked::before {\n  content: \"ON\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sp-content-toggle-area.sp-label input[type=\"checkbox\"]::before {\n  border-radius: 0;\n  content: \"OFF\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sp-content-toggle-area input[type=\"checkbox\"]:checked::before {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n  background: #fff;\n}\n\n.sp-content-toggle-area input[type=\"checkbox\"]:checked {\n  background: #696969;\n}\n\n.sp-contenttoggle-size-large .sp-content-toggle-area input[type=\"checkbox\"] {\n  width: 100px;\n  height: 50px;\n}\n\n.sp-contenttoggle-size-large\n  .sp-content-toggle-area\n  input[type=\"checkbox\"]::before {\n  width: 50px;\n  height: 50px;\n}\n\n.sp-contenttoggle-size-small .sp-content-toggle-area input[type=\"checkbox\"] {\n  width: 60px;\n  height: 30px;\n}\n\n.sp-contenttoggle-size-small\n  .sp-content-toggle-area\n  input[type=\"checkbox\"]::before {\n  width: 30px;\n  height: 30px;\n}\n\n.sp-contenttoggle-size-small\n  .sp-content-toggle-area.sp-label\n  input[type=\"checkbox\"]::before {\n  font-size: 12px;\n}\n\n.sp-contenttoggle-size-mini .sp-content-toggle-area input[type=\"checkbox\"] {\n  width: 40px;\n  height: 20px;\n}\n\n.sp-contenttoggle-size-mini\n  .sp-content-toggle-area\n  input[type=\"checkbox\"]::before {\n  width: 20px;\n  height: 20px;\n}\n\n.sp-contenttoggle-size-mini\n  .sp-content-toggle-area.sp-label\n  input[type=\"checkbox\"]::before {\n  font-size: 10px;\n}\n\n.post-password-form {\n  align-items: center;\n  flex-direction: column;\n  display: flex;\n}\n\n.post-password-form p {\n  padding: 1rem;\n}\n\n.post-password-form p input[type=\"submit\"] {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.sp-alert-info {\n  background: #e1effe;\n  color: #1a56db;\n  border-color: #1a56db;\n}\n\n.sp-alert-success {\n  background: #def7ec;\n  color: #046c4e;\n  border-color: #046c4e;\n}\n\n.sp-alert-warning {\n  background: #fdf6b2;\n  color: #8e4b10;\n  border-color: #8e4b10;\n}\n\n.sp-alert-danger {\n  background: #fde8e8;\n  color: #c81e1e;\n  border-color: #c81e1e;\n}\n\n.sp-alert-style-style1 {\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n}\n\n.sp-alert-style-style2 {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top-width: 4px;\n}\n\n.sp-alert-style-style3 {\n  border-left-width: 4px;\n}\n\n.sp-alert-style-style4 {\n  border-width: 1px;\n  border-radius: 15px;\n}\n\n.sp-alert-style-style4 .sp-alert-block-title-block {\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n}\n\n.sp-alert-style-style3 .sp-alert-block-title,\n.sp-alert-style-style3 .sp-alert-block-title-block {\n  padding-bottom: 0;\n}\n\n.sp-alert-style-style1 .sp-alert-block-title-block,\n.sp-alert-style-style2 .sp-alert-block-title-block {\n  padding-bottom: 0;\n}\n\n.sp-alert-close {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  padding: 3px;\n  font-size: 20px;\n  line-height: 1;\n  background: transparent;\n  color: inherit;\n  border: 0;\n  cursor: pointer;\n}\n\n.sp-alert-close:focus {\n  outline: 0;\n}\n\n.sp-type-alert {\n  position: relative;\n}\n\n.pabloo-business-review-wrapper {\n  padding-right: calc(25px / 2);\n  padding-left: calc(25px / 2);\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.pabloo-business-review-image {\n  width: 60px;\n  height: 60px;\n  display: inline-block;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  border-radius: 50%;\n}\n\n.sp-busines-review-block-preview.review-display-grid.review-grid_column-1\n  .pabloo-business-review-wrapper,\n.sp-busines-review-block-preview.review-display-carousel.review-carousel-1\n  .pabloo-business-review-wrapper {\n  width: 100%;\n}\n\n.sp-busines-review-block-preview.review-display-grid.review-grid_column-2\n  .pabloo-business-review-wrapper,\n.sp-busines-review-block-preview.review-display-carousel.review-carousel-2\n  .pabloo-business-review-wrapper {\n  width: 50%;\n}\n\n.sp-busines-review-block-preview.review-display-grid.review-grid_column-3\n  .pabloo-business-review-wrapper,\n.sp-busines-review-block-preview.review-display-carousel.review-carousel-3\n  .pabloo-business-review-wrapper {\n  width: 33.33%;\n}\n\n.sp-busines-review-block-preview.review-display-grid.review-grid_column-4\n  .pabloo-business-review-wrapper,\n.sp-busines-review-block-preview.review-display-carousel.review-carousel-4\n  .pabloo-business-review-wrapper {\n  width: 25%;\n}\n\n.sp-busines-review-block-preview.review-display-grid.review-grid_column-5\n  .pabloo-business-review-wrapper,\n.sp-busines-review-block-preview.review-display-carousel.review-carousel-5\n  .pabloo-business-review-wrapper {\n  width: 20%;\n}\n\n.sp-busines-review-block-preview.review-display-grid\n  .pabloo-business-reviews-block {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -10px;\n}\n\n.sp-busines-review-block-preview.review-display-carousel\n  .pabloo-business-reviews-block {\n  display: flex;\n  grid-gap: 0.5rem;\n  gap: 0.5rem;\n  text-align: left;\n  z-index: 0;\n}\n\n.fa-star-yellow {\n  color: #f29b2c;\n}\n\n.fa-star-gray {\n  color: #aab2ba;\n}\n\n@media only screen and (max-width: 786px) {\n  .pabloo-business-review-wrapper {\n    padding-right: calc(10px / 2);\n    padding-left: calc(10px / 2);\n    margin-bottom: 10px;\n    text-align: center;\n  }\n}\n\n.sp-particle-wrapper {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.sp-product-gallery-images-shortcode .woocommerce-product-gallery {\n  position: relative;\n  margin-bottom: 2.617924em;\n  margin-top: 0;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .woocommerce-product-gallery__trigger {\n  position: absolute;\n  top: 0.875em;\n  right: 0.875em;\n  display: block;\n  height: 2em;\n  width: 2em;\n  border-radius: 3px;\n  z-index: 99;\n  text-align: center;\n  text-indent: -999px;\n  overflow: hidden;\n  text-decoration: none;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .woocommerce-product-gallery__trigger::before {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  line-height: inherit;\n  vertical-align: baseline;\n  content: \"ï€Ž\";\n  display: block;\n  line-height: 2;\n  text-indent: 0;\n  text-decoration: none;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .flex-control-thumbs {\n  margin: 0;\n  padding: 0;\n  list-style: decimal;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .flex-viewport {\n  margin-bottom: 1.618em;\n}\n\n.sp-product-gallery-images-shortcode .woocommerce-product-gallery .zoomImg {\n  background-color: #fff;\n}\n\n.sp-product-gallery-images-shortcode .woocommerce-product-gallery img {\n  width: 100%;\n  height: auto;\n  box-shadow: none;\n  margin: 0;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .flex-control-thumbs {\n  margin: 0;\n  padding: 0;\n  display: flow-root;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery.woocommerce-product-gallery--columns-4\n  .flex-control-thumbs\n  li:nth-child(4n) {\n  margin-right: 0;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .flex-control-thumbs::before,\n.woocommerce-product-gallery .flex-control-thumbs::after {\n  content: \"\";\n  display: table;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .flex-control-thumbs\n  li\n  img {\n  opacity: 0.5;\n  transition: all, ease, 0.2s;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .flex-control-thumbs\n  li\n  img.flex-active {\n  opacity: 1;\n}\n\n.sp-product-gallery-images-shortcode\n  .woocommerce-product-gallery\n  .flex-control-thumbs\n  li {\n  list-style: none;\n  margin-bottom: 10px;\n  cursor: pointer;\n  width: 14.2857142857%;\n  float: left;\n  margin-right: 14.2857142857%;\n}\n\n#edd_purchase_form_wrap .edd-submit {\n  margin-top: 10px;\n}\n\n#edd_checkout_wrap table#edd_checkout_cart {\n  border-collapse: collapse !important;\n}\n\n#edd_checkout_wrap input[type=\"number\"],\n#edd_checkout_wrap input[type=\"tel\"],\n#edd_checkout_wrap input[type=\"text\"],\n#edd_checkout_wrap input[type=\"password\"],\n#edd_checkout_wrap input[type=\"email\"],\n#edd_checkout_wrap select,\n#edd_checkout_wrap textarea,\n.select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  padding: 10px;\n}\n\n#edd_checkout_wrap #edd_final_total_wrap {\n  margin-bottom: 10px;\n}\n\n.edd_downloads_list .edd_go_to_checkout {\n  margin-top: 10px;\n}\n\n.edd_downloads_list .edd_download div.edd_download_image {\n  margin-bottom: 1rem;\n}\n\n.edd_downloads_list .edd_download .edd_download_title {\n  margin-bottom: 1rem;\n}\n\n.edd_downloads_list .edd_download div.edd_download_full_content {\n  margin-bottom: 1rem;\n}\n\n.edd_downloads_list .edd_download div.edd_price {\n  margin-bottom: 1rem;\n}\n\n.edd_downloads_list .edd_download div.edd_download_buy_button {\n  margin-bottom: 1rem;\n}\n\n.edd_downloads_list .edd_download div.edd_download_excerpt {\n  margin-bottom: 1rem;\n}\n\n.edd_downloads_list .edd_download .edd_download_quantity_wrapper {\n  margin-bottom: 1rem;\n}\n\n.sp-edd-cart-wrapper .edd-cart-number-of-items {\n  margin-bottom: 10px;\n  padding: 10px;\n}\n\n.sp-edd-cart-wrapper ul.edd-cart {\n  list-style: none;\n  padding: 10px;\n}\n\n.sp-edd-cart-wrapper li.edd-cart-item {\n  text-align: end;\n}\n\n.sp-edd-cart-wrapper li span.edd-cart-item-title {\n  float: left;\n}\n\n.sp-edd-cart-wrapper .edd-cart-item .edd-cart-item-separator {\n  display: none !important;\n}\n\n.sp-edd-cart-wrapper li.edd-cart-meta.edd_total {\n  margin-bottom: 1rem;\n  text-align: right;\n}\n\n.sp-edd-cart-wrapper li.cart_item.edd_checkout a.sp-button {\n  padding: 6px 12px;\n}\n\n.sp-edd-cart-wrapper ul.edd-cart li:not(.edd_checkout) {\n  padding: 1rem;\n}\n\n.sp-edd-cart-wrapper li.cart_item.edd_checkout {\n  margin-bottom: 1rem;\n}\n\n.edd_download_purchase_form input[type=\"number\"],\n.edd_download_purchase_form input[type=\"tel\"],\n.edd_download_purchase_form input[type=\"text\"],\n.edd_download_purchase_form input[type=\"password\"],\n.edd_download_purchase_form input[type=\"email\"],\n.edd_download_purchase_form select {\n  padding: 10px;\n}\n\n.sp-video-pop-up-block .sp-video-wrapper .sp-video-responsive,\n.sp-video-pop-up-block .sp-video-responsive-video {\n  height: 100%;\n  width: 100%;\n}\n\n.sp-video-pop-up-block .sp-video-wrapper .sp-video-responsive-video video {\n  height: 100%;\n  width: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.sp-video-pop-up-block .sp-video-responsive-video {\n  overflow: hidden;\n  position: relative;\n}\n\n.sp-video-pop-up-block .sp-video-wrapper-sticky {\n  height: 500px;\n}\n\n.sp-video-pop-up-block .sp-video-responsive-sticky {\n  position: fixed;\n  right: 15px;\n  bottom: 15px;\n  max-width: 550px;\n  width: 500px;\n  z-index: 9999;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-banner-sticky {\n  position: fixed;\n  right: 15px;\n  bottom: 330px;\n  max-width: 550px;\n  width: 500px;\n  z-index: 9999;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-banner-custom-sticky {\n  position: fixed;\n  right: 15px;\n  bottom: 295px;\n  max-width: 550px;\n  width: 500px;\n  z-index: 9999;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-banner-vimeo-sticky {\n  position: fixed;\n  right: 15px;\n  bottom: 315px;\n  max-width: 550px;\n  width: 500px;\n  z-index: 9999;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-banner {\n  width: 100%;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-banner-text {\n  padding: 5px;\n}\n\n.sp-video-pop-up-block .sp-video-responsive-sticky iframe,\n.sp-video-pop-up-block .sp-video-responsive-sticky video {\n  position: fixed !important;\n  right: 15px;\n  bottom: 15px;\n  max-width: 550px;\n  width: 500px;\n}\n\n.sp-video-pop-up-block .sp-video-wrapper a.sp-video-responsive {\n  display: block !important;\n  color: inherit !important;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-placeholder {\n  display: none !important;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-overlay-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: 50%;\n  cursor: pointer;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-overlay-play-icon-display {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-teaser-video-play-icon-display {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n\n.sp-video-pop-up-block .sp-video-pop-up-teaser-video-play-icon-display i {\n  cursor: pointer;\n}\n\n.sp-video-pop-up-block .video-pop-up-modal {\n  display: none;\n  position: fixed;\n  z-index: 9999;\n  padding-top: 100px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n\n.sp-video-pop-up-block .video-pop-up-modal .modal-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  margin: auto;\n  padding: 0;\n  width: 90%;\n  max-width: 1200px;\n}\n\n.sp-video-pop-up-block .video-pop-up-modal .close {\n  color: white;\n  position: absolute;\n  top: 10px;\n  right: 25px;\n  font-size: 35px;\n  font-weight: bold;\n}\n\n.sp-video-pop-up-block .video-pop-up-modal .close:hover,\n.sp-video-pop-up-block .video-pop-up-modal .close:focus {\n  color: #999;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.sp-skin-card .sp-posts-single-block {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n}\n\n.sp-skin-card .sp-posts-single-block .sp-container-badge {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 0.1em 1.2em;\n  background: black;\n  margin: 10px;\n  color: #fff;\n  border-radius: 15px;\n}\n\n.sp-skin-card .sp-posts-single-block .sp-container-avatar {\n  position: relative;\n  padding: 0 30px;\n  width: 100%;\n  top: -25px;\n  height: 0;\n  pointer-events: none;\n}\n\n.sp-posts-inner-block .sp-container.sp-mb-5 {\n  margin-bottom: 1.25rem;\n}\n\n.sp-skin-card .sp-posts-single-block .sp-container-avatar img {\n  border-radius: 50%;\n  width: 60px;\n  pointer-events: all;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.sp-skin-card .sp-posts-single-block {\n  background: #fff;\n}\n\n.sp-skin-card .post-text-container {\n  flex-grow: 1;\n}\n\n.sp-skin-card.sp-post-masonary-true {\n  align-items: flex-start;\n}\n\n.sp-skin-card.sp-post-masonary-true .sp-posts-single-block {\n  padding-right: calc(20px / 2);\n  padding-left: calc(20px / 2);\n  margin-bottom: 20px;\n}\n\n.sp-skin-card .sp-posts-single-block .sp-posts-inner-block {\n  display: flex;\n  flex-direction: column;\n}\n\n.sp-columns-1.sp-post-masonary-true .sp-posts-single-block {\n  width: 100%;\n}\n\n.sp-columns-2.sp-post-masonary-true .sp-posts-single-block {\n  width: 50%;\n}\n\n.sp-columns-3.sp-post-masonary-true .sp-posts-single-block {\n  width: 33.33%;\n}\n\n.sp-columns-4.sp-post-masonary-true .sp-posts-single-block {\n  width: 25%;\n}\n\n.sp-columns-5.sp-post-masonary-true .sp-posts-single-block {\n  width: 20%;\n}\n\n.sp-grid-cols-1.sp-post-masonary-true .sp-posts-single-block {\n  width: 100%;\n}\n\n.sp-grid-cols-2.sp-post-masonary-true .sp-posts-single-block {\n  width: 50%;\n}\n\n.sp-grid-cols-3.sp-post-masonary-true .sp-posts-single-block {\n  width: 33.33%;\n}\n\n.sp-grid-cols-4.sp-post-masonary-true .sp-posts-single-block {\n  width: 25%;\n}\n\n.sp-grid-cols-5.sp-post-masonary-true .sp-posts-single-block {\n  width: 20%;\n}\n\n.sp-post-masonary-true {\n  flex-wrap: wrap;\n}\n\n.sp-layout-masonary {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n\n.sp-layout-masonary .pabloo-masonary-post-block {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.sp-post-masonary-true:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.sp-creative-posts .sp-posts-inner-block {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n}\n\n.sp-creative-posts .sp-posts-inner-block .sp-thumbnail {\n  width: calc(100% - 50%);\n}\n\n.sp-creative-posts .sp-posts-inner-block.post_no_image {\n  padding: 30px 5px;\n}\n\n.sp-creative-posts .sp-posts-inner-block.post_no_image .sp-post-text-container {\n  width: 100%;\n}\n\n.sp-posts-single-block .sp-container-badge {\n  padding: 4px 10px;\n}\n\n.sp-creative-posts .sp-posts-inner-block.sp-right-side-image {\n  flex-direction: row-reverse;\n}\n\n.sp-creative-posts\n  .sp-posts-inner-block.sp-left-side-image:not(.post_no_image)\n  .sp-post-text-container {\n  margin-left: -30px;\n}\n\n.sp-creative-posts\n  .sp-posts-inner-block.sp-right-side-image:not(.post_no_image)\n  .sp-post-text-container {\n  margin-right: -30px;\n}\n\n.sp-creative-posts\n  .sp-posts-inner-block:not(.post_no_image)\n  .sp-post-text-container {\n  width: calc(50% + 25px);\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.sp-creative-posts .sp-posts-inner-block .sp-post-text-container {\n  background-color: #fff;\n  padding: 30px 30px 30px 30px;\n  box-shadow: 0 1px 25px rgba(0, 0, 0, 0.05);\n  z-index: 1;\n}\n\n.sp-skin-minimal .sp-posts-single-block.sp-minimal-posts:first-child {\n  border-top: 0;\n}\n\n.sp-skin-minimal .sp-posts-single-block.sp-minimal-posts {\n  padding: 1rem 2px;\n  margin: 0;\n}\n\n.sp-skin-minimal.sp-layout-masonary .sp-posts-single-block.sp-minimal-posts {\n  padding: 1rem 6px;\n}\n\n.sp-minimal-posts .sp-posts-inner-block {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n}\n\n.sp-minimal-posts .sp-posts-inner-block .sp-thumbnail {\n  width: calc(100% - 70%);\n}\n\n.sp-minimal-posts .sp-posts-inner-block.post_no_image .sp-post-text-container {\n  width: 100%;\n}\n\n.sp-minimal-posts .sp-posts-inner-block.sp-right-side-image {\n  flex-direction: row-reverse;\n}\n\n.sp-minimal-posts\n  .sp-posts-inner-block.sp-left-side-image:not(.post_no_image)\n  .sp-post-text-container {\n  margin-left: 0;\n}\n\n.sp-minimal-posts\n  .sp-posts-inner-block.sp-right-side-image:not(.post_no_image)\n  .sp-post-text-container {\n  margin-right: 0;\n}\n\n.sp-minimal-posts\n  .sp-posts-inner-block:not(.post_no_image)\n  .sp-post-text-container {\n  width: 70%;\n}\n\n.sp-minimal-posts .sp-posts-inner-block .sp-post-text-container {\n  padding: 20px 20px 20px 20px;\n  z-index: 1;\n}\n\n.sp-minimal-posts .sp-thumbnail {\n  border-radius: 15px;\n}\n\n.sp-news-posts .sp-featured-image {\n  margin-bottom: 5px;\n}\n\n.sp-layout-gridlayout.sp-skin-news.sp-gap-4 {\n  grid-gap: 0;\n  gap: 0;\n}\n\n.sp-posts-single-block.sp-news-posts:first-child {\n  border-left: 0;\n}\n\n.sp-posts-single-block.sp-news-posts {\n  border-left: 1px solid;\n  padding: 0 1rem;\n  margin-bottom: 10px;\n}\n\n.pabloo-carousel-post-block .sp-posts-single-block.sp-card-posts,\n.sp-skin-minimal\n  .pabloo-carousel-post-block\n  .sp-posts-single-block.sp-minimal-posts {\n  margin: 0 10px;\n}\n\n.pabloo-carousel-post-block .sp-posts-single-block {\n  margin: 0 10px;\n}\n\n.sp-layout-gridlayout.sp-skin-minimal.sp-gap-4 {\n  grid-gap: 0;\n  gap: 0;\n}\n\n.sp-layout-gridlayout .sp-posts-single-block.sp-minimal-posts {\n  margin: 0 10px;\n}\n\n.sp-featured-image .sp-posts-image-link,\n.sp-featured-image .sp-posts-image-link img {\n  width: 100%;\n}\n\n.sp-posts-block-wrapper .sp-layout-carousel {\n  display: flex;\n  flex-direction: column;\n}\n\n.sp-posts-block-wrapper .pabloo-carousel-post-block {\n  display: flex;\n}\n\n.sp-layout-masonary {\n  grid-gap: 1rem;\n  gap: 1rem;\n  row-gap: 1rem;\n}\n\n.sp-layout-masonary .sp-posts-single-block {\n  padding: 5px;\n  margin-bottom: 0.5rem;\n}\n\n.sp-grid-cols-1.sp-layout-masonary .sp-posts-single-block {\n  width: 100%;\n}\n\n.sp-grid-cols-2.sp-layout-masonary .sp-posts-single-block {\n  width: calc(50% - 1rem);\n  margin: 0.5rem;\n}\n\n.sp-grid-cols-3.sp-layout-masonary .sp-posts-single-block {\n  width: calc(33.33% - 1rem);\n  margin: 0.5rem;\n}\n\n.sp-grid-cols-4.sp-layout-masonary .sp-posts-single-block {\n  width: calc(25% - 1rem);\n  margin: 0.5rem;\n}\n\n.sp-grid-cols-5.sp-layout-masonary .sp-posts-single-block {\n  width: calc(20% - 1rem);\n  margin: 0.5rem;\n}\n\n.sp-grid-cols-1.pabloo-carousel-post-block .sp-posts-single-block {\n  width: 100%;\n}\n\n.sp-grid-cols-2.pabloo-carousel-post-block .sp-posts-single-block {\n  width: 50%;\n}\n\n.sp-grid-cols-3.pabloo-carousel-post-block .sp-posts-single-block {\n  width: 33.33%;\n}\n\n.sp-grid-cols-4.pabloo-carousel-post-block .sp-posts-single-block {\n  width: 25%;\n}\n\n.sp-grid-cols-5.pabloo-carousel-post-block .sp-posts-single-block {\n  width: 20%;\n}\n\n.sp-gap-4 .pabloo-carousel-post-block {\n  grid-gap: 0;\n  gap: 0;\n}\n\n.sp-layout-carousel .sp-posts-single-block.show-carousel-area {\n  transition: opacity 0.3s linear 0s;\n  opacity: 1;\n  z-index: 999;\n}\n\n.sp-layout-carousel .sp-posts-single-block.hidden-carousel-area {\n  opacity: 0;\n  position: absolute;\n}\n\n.sp-layout-masonary .sp-posts-single-block.sp-news-posts {\n  border-left: 0;\n}\n\n.sp-skin-block .sp-posts-image img {\n  width: 100%;\n}\n\n.pabloo-carousel-post-block .sp-posts-single-block.sp-minimal-posts,\n.sp-layout-masonary .sp-posts-single-block.sp-minimal-posts {\n  border-top: 0;\n}\n\n.woocommerce-page\n  .widget-content-block\n  .select2-container\n  .select2-search__field,\n.woocommerce-page .select2-container .select2-selection {\n  height: auto;\n}\n\n.woocommerce-page\n  .widget-content-block\n  .select2-container\n  .select2-selection.select2-selection--single {\n  min-height: 60px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n@media screen and (max-width: 768px) {\n  .image-preview-container #preview-image,\n  .image-preview-container #preview-image {\n    width: auto !important;\n    height: auto !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n    position: fixed !important;\n    top: 50% !important;\n    left: 50% !important;\n    -webkit-transform: translate(-50%, -50%) !important;\n    transform: translate(-50%, -50%) !important;\n    -o-object-fit: contain !important;\n    object-fit: contain !important;\n  }\n}\n\n@media (min-width: 640px) {\n  .sm\\:sp-flex {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
